// import React, { useState, useEffect, useRef } from "react";
// import "./DppScheduling.css";
// import DropDown from "./DropdwonClassic";
// import InputComponent from "../TestScheduling/Input-testscheduling";
// import TextEditor from "./TextEditor";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import SucessImg from "../../../Assets/Images/CommanImages/success.png";
// import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
// import MultiSelectSearchDropdown from "./MultiDropdownClassic";
// import { useLocation } from "react-router-dom";
// import { IoCheckmarkCircle } from "react-icons/io5";
// import { POST } from "../../../Api/HttpsMethods";
// import { GET } from "../../../Api/HttpsMethods";
// import EndPoints from "../../../Api/Endpoints";
// import { useNavigate } from "react-router-dom";
// import Colors from "../../../Constants/Colors";

// const DppScheduling = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const location = useLocation();
//   const dppData = location.state;
//   const navigate = useNavigate();

//   console.log(dppData?.dpp_name);

//   useEffect(() => {
//     if (dataClient) {
//       const userName =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//       const clientBranchId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//       const clientId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

//       sessionStorage.setItem("user_name", userName);
//       sessionStorage.setItem("clientBranchId", clientBranchId);
//       sessionStorage.setItem("clientId", clientId);
//     }
//   }, [dataClient]);

//   const userName =
//     dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
//     sessionStorage.getItem("user_name") ||
//     "";

//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
//     sessionStorage.getItem("clientBranchId") ||
//     null;

//   const clientId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
//     sessionStorage.getItem("clientId") ||
//     null;

//   const [selectedQuestionPaperSubjects, setSelectedQuestionPaperSubjects] =
//     useState("");

//   const [selectedChapterId, setSelectedChapterId] = useState([]);
//   const [selectedChapterName, setSelectedChapterName] = useState("");
//   const [selectedTopicId, setSelectedTopicId] = useState([]);
//   const [selectedTopicName, setSelectedTopicName] = useState("");
//   const [instructionsHtml, setInstructionsHtml] = useState("");
//   const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
//   const [selectedQuestionPaperName, setSelectedQuestionPaperName] =
//     useState("");
//   const [
//     selectedQuestionPaperDescription,
//     setSelectedQuestionPaperDescription,
//   ] = useState("");
//   const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] =
//     useState("");
//   const [testTemplates, setTestTemplates] = useState([]);
//   const [courses, setCourses] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [chapters, setChapters] = useState([]);
//   const [topics, setTopics] = useState([]);
//   const [questionPapers, setQuestionPapers] = useState([]);

//   // Separate states for course id and course name
//   const [selectedCourseId, setSelectedCourseId] = useState("");
//   const [selectedCourseName, setSelectedCourseName] = useState("");

//   // States for subject id and subject name
//   const [selectedSubjectSupersetId, setSelectedSubjectSupersetId] = useState("");
//   const [selectedSubjectSupersetName, setSelectedSubjectSupersetName] = useState("");
//   const [selectedSubjectIds, setSelectedSubjectIds] = useState([]); // Array of subject IDs

//   // Course Plans state
//   const [coursePlans, setCoursePlans] = useState([]);
//   const [coursePlanCardData, setCoursePlanCardData] = useState({});
//   const [expandedCards, setExpandedCards] = useState({}); // Track which cards are expanded

//   // Folder picker states
//   const [folderLevelData, setFolderLevelData] = useState({});
//   const [activeFolderPicker, setActiveFolderPicker] = useState(null);
//   const [expandedLevel1, setExpandedLevel1] = useState(null);
//   const [expandedLevel2, setExpandedLevel2] = useState(null);
//   const [expandedLevel3, setExpandedLevel3] = useState(null);
//   const [folderSearchText, setFolderSearchText] = useState({});
//   const folderPickerRef = useRef(null);
//   const dropdownRef = useRef(null); // Added separate ref for dropdown menu

//   // Track if cards have been applied - used to warn on course/question paper change
//   const [hasAppliedCards, setHasAppliedCards] = useState(false);

//   // Track active copy dropdown
//   const [activeCopyDropdown, setActiveCopyDropdown] = useState(null);
//   const copyDropdownRef = useRef(null);

//   // Close folder picker when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       // Check if click is outside BOTH the input field AND the dropdown menu
//       if (
//         activeFolderPicker &&
//         folderPickerRef.current &&
//         !folderPickerRef.current.contains(event.target) &&
//         (!dropdownRef.current || !dropdownRef.current.contains(event.target))
//       ) {
//         setActiveFolderPicker(null);
//         setExpandedLevel1(null);
//         setExpandedLevel2(null);
//         setExpandedLevel3(null);
//         setFolderSearchText({});
//       }

//       // Close copy dropdown when clicking outside
//       if (
//         activeCopyDropdown &&
//         copyDropdownRef.current &&
//         !copyDropdownRef.current.contains(event.target)
//       ) {
//         setActiveCopyDropdown(null);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [activeFolderPicker, activeCopyDropdown]);

//   // Fetch Course Plans when course is selected
//   useEffect(() => {
//     const fetchCoursePlans = async () => {
//       if (!selectedCourseId) {
//         setCoursePlans([]);
//         return;
//       }

//       try {
//         const API_ENDPOINT = `${EndPoints.PRISM_GET_COURSE_PLAN}?course_id=${selectedCourseId}`;
//         const result = await GET.withToken(API_ENDPOINT);

//         if (result?.status === 200 && Array.isArray(result.data)) {
//           setCoursePlans(result.data);

//           // Initialize card data for each plan
//           const initialData = {};
//           const initialExpanded = {};
//           result.data.forEach((plan) => {
//             initialData[plan.course_plan_id] = {
//               dppName: "",
//               description: "",
//               startDate: "",
//               termDate: "",
//               folderName: "",
//               folderPath: "",
//               selectedLevel1Id: null,
//               selectedLevel2Id: null,
//               selectedLevel3Id: null,
//               isApplied: false,
//               originalData: null, // Store original for comparison
//               hasChanges: false, // Track if this card has been modified
//             };
//             initialExpanded[plan.course_plan_id] = false;
//           });
//           setCoursePlanCardData(initialData);
//           setExpandedCards(initialExpanded);

//           // Fetch folder level data for each plan
//           result.data.forEach((plan) => {
//             fetchFolderLevels(plan.course_plan_id);
//           });
//         } else {
//           setCoursePlans([]);
//         }
//       } catch (error) {
//         console.error("Error fetching course plans:", error);
//         setCoursePlans([]);
//       }
//     };
//     fetchCoursePlans();
//   }, [selectedCourseId]);

//   // Fetch folder level data for a specific course plan
//   const fetchFolderLevels = async (coursePlanId) => {
//     try {
//       const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_FOLDER_STRUCTURE}?course_plan_id=${coursePlanId}`;
//       const result = await GET.withToken(API_ENDPOINT);

//       if (result?.status === 200 && Array.isArray(result.data)) {
//         setFolderLevelData((prev) => ({
//           ...prev,
//           [coursePlanId]: result.data,
//         }));
//       }
//     } catch (error) {
//       console.error("Error fetching folder levels:", error);
//     }
//   };

//   // Fetch existing DPP schedule when question paper is selected
//   const fetchExistingDppSchedule = async (quesPaperId) => {
//     try {
//       const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_SCHEDULE_BY_QUES_PAPER_ID}?ques_paper_id=${quesPaperId}`;
//       const result = await GET.withToken(API_ENDPOINT);

//       if (result?.status === 200 && Array.isArray(result.data) && result.data.length > 0) {
//         // Populate cards with existing data
//         const updatedCardData = { ...coursePlanCardData };
//         const updatedExpanded = { ...expandedCards };

//         result.data.forEach((schedule) => {
//           const planId = schedule.course_plan_id;
//           if (updatedCardData[planId]) {
//             // Build folder path from level data
//             let folderPath = "";
//             const levelData = folderLevelData[planId];
//             if (levelData && schedule.dpp_level1_id) {
//               const level1 = levelData.find(l => l.dpp_level1_id === schedule.dpp_level1_id);
//               if (level1) {
//                 folderPath = level1.name;
//                 if (schedule.dpp_level2_id && level1.level2) {
//                   const level2 = level1.level2.find(l => l.dpp_level2_id === schedule.dpp_level2_id);
//                   if (level2) {
//                     folderPath += ` > ${level2.name}`;
//                     if (schedule.dpp_level3_id && level2.level3) {
//                       const level3 = level2.level3.find(l => l.dpp_level3_id === schedule.dpp_level3_id);
//                       if (level3) {
//                         folderPath += ` > ${level3.name}`;
//                       }
//                     }
//                   }
//                 }
//               }
//             }

//             updatedCardData[planId] = {
//               dppScheduleId: schedule.dpp_schedule_id,
//               dppName: schedule.dpp_name || "",
//               description: schedule.dpp_desc || "",
//               startDate: schedule.dpp_window_start ? schedule.dpp_window_start.replace(" ", "T").slice(0, 16) : "",
//               termDate: schedule.dpp_term_date ? schedule.dpp_term_date.replace(" ", "T").slice(0, 16) : "",
//               folderName: folderPath,
//               folderPath: folderPath,
//               selectedLevel1Id: schedule.dpp_level1_id,
//               selectedLevel2Id: schedule.dpp_level2_id,
//               selectedLevel3Id: schedule.dpp_level3_id,
//               isApplied: true,
//               originalData: { ...schedule, folderPath },
//               hasChanges: false, // No changes initially
//             };
//             updatedExpanded[planId] = true; // Expand cards with existing data
//           }
//         });

//         setCoursePlanCardData(updatedCardData);
//         setExpandedCards(updatedExpanded);
//       }
//     } catch (error) {
//       console.error("Error fetching existing DPP schedule:", error);
//     }
//   };

//   useEffect(() => {
//     if (!userName || !clientBranchId) return;

//     const fetchTestTemplates = async () => {
//       try {
//         const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_INSTRUCTIONS_TEMPLATE_LIST}?username=${userName}&branch_id=${clientBranchId}`;
//         const data = await GET.withToken(API_ENDPOINT);

//         // if (data) {
//         //   setTestTemplates(data);
//         // }
//         if (data && data.status === 200 && Array.isArray(data.data)) {
//           setTestTemplates(data.data);
//         } else if (data && Array.isArray(data)) {
//           setTestTemplates(data);
//         }
//       } catch (error) {
//         console.error("Error fetching test templates:", error);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error fetching test templates: {error.message}</span>
//               </div>
//             </div>
//           );
//           setIsMessageBoxVisible(true);
//           setActiveImg(ErrorImg);
//         }
//       }
//     };
//     fetchTestTemplates();
//   }, [userName, clientBranchId]);

//   // Fetch Courses
//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const data = await GET.withToken(EndPoints.PRISM_GET_COURSES);
//         if (data) {
//           setCourses(data);
//         }
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <span>Error fetching courses: {error.message}</span>
//               </div>
//             </div>
//           );
//           setIsMessageBoxVisible(true);
//           setActiveImg(ErrorImg);
//         }
//       }
//     };
//     fetchCourses();
//   }, []);

//   useEffect(() => {
//     const fetchSubjects = async () => {
//       if (!selectedCourseId) return;
//       try {
//         const API_ENDPOINT = `${EndPoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourseId}`;
//         const data = await GET.withToken(API_ENDPOINT);
//         if (data) setSubjects(data);
//       } catch (error) {
//         console.error("Error fetching subjects:", error);
//       }
//     };
//     fetchSubjects();
//   }, [selectedCourseId]);

//   useEffect(() => {
//     const fetchChapters = async () => {
//       if (!selectedSubjectIds || selectedSubjectIds.length === 0) return;
//       try {
//         const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${selectedSubjectIds.join('&subject_superset_id=')}`;
//         const data = await GET.withToken(API_ENDPOINT);
//         if (data) setChapters(data);
//       } catch (error) {
//         console.error("Error fetching chapters:", error);
//       }
//     };
//     fetchChapters();
//   }, [selectedSubjectIds]);

//   useEffect(() => {
//     const fetchTopics = async () => {
//       if (
//         !selectedChapterId ||
//         !Array.isArray(selectedChapterId) ||
//         selectedChapterId.length === 0
//       ) {
//         setTopics([]);
//         return;
//       }
//       const data = await POST.withToken(
//         EndPoints.PRISM_GET_TOPICS_BY_CHAPTER_LIST,
//         selectedChapterId,
//         { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
//       );
//       if (data && data.status_code === 200 && Array.isArray(data.data)) {
//         setTopics(data.data);
//       } else {
//         setTopics([]);
//       }
//     };
//     fetchTopics();
//   }, [selectedChapterId]);

//   // Fetch Question Papers when subject is selected (with optional chapter and topic filters)
//   useEffect(() => {
//     const fetchQuestionPapers = async () => {
//       if (!selectedSubjectIds || selectedSubjectIds.length === 0) {
//         setQuestionPapers([]);
//         return;
//       }

//       try {
//         let API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_QUESTION_PAPER}?`;
        
//         // Add subject_ids parameters
//         selectedSubjectIds.forEach((id) => {
//           API_ENDPOINT += `subject_superset_ids=${id}&`;
//         });

//         // Add optional chapter filter
//         if (Array.isArray(selectedChapterId) && selectedChapterId.length > 0) {
//           selectedChapterId.forEach((id) => {
//             API_ENDPOINT += `chapter_id=${id}&`;
//           });
//         }

//         // Add optional topic filter
//         if (Array.isArray(selectedTopicId) && selectedTopicId.length > 0) {
//           selectedTopicId.forEach((id) => {
//             API_ENDPOINT += `topic_id=${id}&`;
//           });
//         }

//         // Remove trailing '&' or '?'
//         API_ENDPOINT = API_ENDPOINT.replace(/[&?]$/, '');

//         const result = await GET.withToken(API_ENDPOINT);

//         if (result?.status === 200 && Array.isArray(result.data)) {
//           setQuestionPapers(result.data);
//         } else {
//           setQuestionPapers([]);
//         }
//       } catch (error) {
//         console.error("Error fetching question papers:", error);
//         setQuestionPapers([]);
//       }
//     };

//     fetchQuestionPapers();
//   }, [selectedSubjectIds, selectedChapterId, selectedTopicId]);

//   // Helper function to update card data
//   const updateCardData = (planId, field, value) => {
//     setCoursePlanCardData((prev) => {
//       const currentData = prev[planId] || {};
//       const newData = {
//         ...currentData,
//         [field]: value,
//         isApplied: false, // Mark as not applied when any change is made
//         hasChanges: true, // Mark that this card has been modified
//       };

//       return {
//         ...prev,
//         [planId]: newData,
//       };
//     });
//   };

//   // Handle APPLY button click for a card
//   const handleApplyCard = (planId) => {
//     const cardData = coursePlanCardData[planId];

//     // Validation - all required fields must be filled
//     if (
//       !cardData.dppName?.trim() ||
//       !cardData.description?.trim() ||
//       !cardData.startDate ||
//       !cardData.folderName
//     ) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>
//               Please fill all required fields: DPP Name, Description, Start Date, and Folder Name.
//             </span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       return;
//     }

//     // Create a snapshot of the current state to serve as the new "Original Data"
//     const currentSnapshot = {
//       dpp_name: cardData.dppName,
//       dpp_desc: cardData.description,
//       dpp_window_start: cardData.startDate, 
//       dpp_term_date: cardData.termDate,
//       folderPath: cardData.folderName,
//       dpp_level1_id: cardData.selectedLevel1Id,
//       dpp_level2_id: cardData.selectedLevel2Id,
//       dpp_level3_id: cardData.selectedLevel3Id,
//       dpp_schedule_id: cardData.originalData?.dpp_schedule_id 
//     };

//     // Mark as applied AND update originalData
//     setCoursePlanCardData((prev) => ({
//       ...prev,
//       [planId]: {
//         ...prev[planId],
//         isApplied: true,
//         originalData: currentSnapshot,
//         hasChanges: true, // Keep hasChanges true to include in save
//       },
//     }));

//     // Track that at least one card has been applied
//     setHasAppliedCards(true);
//   };

//   // Handle RESET button click for a card
//   const handleResetCard = (planId) => {
//     const original = coursePlanCardData[planId]?.originalData;

//     if (original) {
//       // Reset to original data
//       let folderPath = original.folderPath || "";

//       setCoursePlanCardData((prev) => ({
//         ...prev,
//         [planId]: {
//           ...prev[planId],
//           dppName: original.dpp_name || "",
//           description: original.dpp_desc || "",
//           startDate: original.dpp_window_start?.replace(" ", "T").slice(0, 16) || "",
//           termDate: original.dpp_term_date?.replace(" ", "T").slice(0, 16) || "",
//           folderName: folderPath,
//           folderPath: folderPath,
//           selectedLevel1Id: original.dpp_level1_id,
//           selectedLevel2Id: original.dpp_level2_id,
//           selectedLevel3Id: original.dpp_level3_id,
//           isApplied: true,
//           hasChanges: false, // No changes after reset
//         },
//       }));
//     } else {
//       // Reset to empty
//       setCoursePlanCardData((prev) => ({
//         ...prev,
//         [planId]: {
//           dppName: "",
//           description: "",
//           startDate: "",
//           termDate: "",
//           folderName: "",
//           folderPath: "",
//           selectedLevel1Id: null,
//           selectedLevel2Id: null,
//           selectedLevel3Id: null,
//           isApplied: false,
//           originalData: null,
//           hasChanges: false,
//         },
//       }));
//     }
//   };

//   // Handle COPY from another plan
//   const handleCopyFromPlan = (targetPlanId, sourcePlanId) => {
//     if (!sourcePlanId || sourcePlanId === targetPlanId) return;
//     const sourceData = coursePlanCardData[sourcePlanId];
//     if (sourceData) {
//       setCoursePlanCardData((prev) => ({
//         ...prev,
//         [targetPlanId]: {
//           ...prev[targetPlanId],
//           dppName: sourceData.dppName,
//           description: sourceData.description,
//           startDate: sourceData.startDate,
//           termDate: sourceData.termDate,
//           folderName: sourceData.folderName,
//           folderPath: sourceData.folderPath,
//           selectedLevel1Id: sourceData.selectedLevel1Id,
//           selectedLevel2Id: sourceData.selectedLevel2Id,
//           selectedLevel3Id: sourceData.selectedLevel3Id,
//           isApplied: false,
//           hasChanges: true, // Mark as changed
//         },
//       }));
//       setActiveCopyDropdown(null);
//     }
//   };

//   // Handle folder selection
//   const handleFolderSelect = (planId, level1, level2, level3 = null) => {
//     let folderPath = "";
//     let selectedLevel1Id = null;
//     let selectedLevel2Id = null;
//     let selectedLevel3Id = null;

//     if (level3) {
//       folderPath = `${level1.name} > ${level2.name} > ${level3.name}`;
//       selectedLevel1Id = level1.dpp_level1_id;
//       selectedLevel2Id = level2.dpp_level2_id;
//       selectedLevel3Id = level3.dpp_level3_id;
//     } else if (level2) {
//       folderPath = `${level1.name} > ${level2.name}`;
//       selectedLevel1Id = level1.dpp_level1_id;
//       selectedLevel2Id = level2.dpp_level2_id;
//     }

//     setCoursePlanCardData((prev) => ({
//       ...prev,
//       [planId]: {
//         ...prev[planId],
//         folderName: folderPath,
//         folderPath: folderPath,
//         selectedLevel1Id,
//         selectedLevel2Id,
//         selectedLevel3Id,
//         isApplied: false,
//         hasChanges: true, // Mark as changed
//       },
//     }));

//     setActiveFolderPicker(null);
//     setExpandedLevel1(null);
//     setExpandedLevel2(null);
//     setExpandedLevel3(null);
//     setFolderSearchText(prev => {
//       const newState = { ...prev };
//       delete newState[planId];
//       return newState;
//     });
//   };

//   // Toggle folder picker visibility
//   const toggleFolderPicker = (planId) => {
//     if (activeFolderPicker === planId) {
//       setActiveFolderPicker(null);
//       setExpandedLevel1(null);
//       setExpandedLevel2(null);
//       setExpandedLevel3(null);
//       setFolderSearchText(prev => {
//         const newState = { ...prev };
//         delete newState[planId];
//         return newState;
//       });
//     } else {
//       setActiveFolderPicker(planId);
//       setExpandedLevel1(null);
//       setExpandedLevel2(null);
//       setExpandedLevel3(null);
//       setFolderSearchText(prev => ({ ...prev, [planId]: "" }));
//     }
//   };

//   // Toggle card expanded state
//   const toggleCardExpanded = (planId) => {
//     if (!selectedQuestionPaperId) return; // Can't expand if not enabled
//     setExpandedCards((prev) => ({
//       ...prev,
//       [planId]: !prev[planId],
//     }));
//   };

//   // Handle Course selection with warning
//   const handleCourseChange = (selectedId) => {
//     // Check if any cards have been filled
//     const hasFilledCards = Object.values(coursePlanCardData).some(
//       card => card.dppName || card.description || card.startDate || card.folderName
//     );
    
//     if (hasFilledCards && selectedCourseId !== selectedId) {
//       // Show warning with Yes/No buttons
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Changing the course will reset all fields and course plan cards. You may lose unsaved data. Do you want to continue?</span>
//           </div>
//           <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//             <button
//               className="messagebox-cancel-btn-ok"
//               onClick={() => {
//                 setIsMessageBoxVisible(false);
//                 // Proceed with course change
//                 proceedWithCourseChange(selectedId);
//               }}
//             >
//               YES
//             </button>
//             <button
//               className="messagebox-cancel-btn-ok"
//               onClick={() => {
//                 setIsMessageBoxVisible(false);
//               }}
//             >
//               NO
//             </button>
//           </div>
//         </div>
//       );
//       setActiveImg(WarnningIcon);
//       return;
//     }

//     // No warning needed, proceed directly
//     proceedWithCourseChange(selectedId);
//   };

//   const proceedWithCourseChange = (selectedId) => {
//     setSelectedCourseId(selectedId);
//     const course = courses.find((c) => c.course_id === selectedId);
//     setSelectedCourseName(course?.course_name || "");
    
//     // Reset all related fields
//     setSelectedSubjectSupersetId("");
//     setSelectedSubjectSupersetName("");
//     setSelectedSubjectIds([]);
//     setSelectedChapterId([]);
//     setSelectedChapterName("");
//     setSelectedTopicId([]);
//     setSelectedTopicName("");
//     setSelectedQuestionPaperId("");
//     setSelectedQuestionPaperName("");
//     setSelectedQuestionPaperDescription("");
//     setSelectedQuestionPaperCreatedBy("");
//     setSelectedQuestionPaperSubjects("");
    
//     // Reset applied cards tracking
//     setHasAppliedCards(false);
//   };

//   const proceedWithSubjectChange = (selectedSupersetId) => {
//     // Find all subjects with this superset_id
//     const matchingSubjects = Array.isArray(subjects)
//       ? subjects.filter(
//           (subject) => subject.subject_superset_id === selectedSupersetId
//         )
//       : [];
    
//     if (matchingSubjects.length > 0) {
//       setSelectedSubjectSupersetId(selectedSupersetId);
//       setSelectedSubjectSupersetName(matchingSubjects[0].subject_superset_name);
//       // Extract all subject_ids for this superset
//       const subjectIds = matchingSubjects.map(s => s.subject_id);
//       setSelectedSubjectIds(subjectIds);
//     } else {
//       setSelectedSubjectSupersetId("");
//       setSelectedSubjectSupersetName("");
//       setSelectedSubjectIds([]);
//     }

//     // Reset chapters, topics, question paper and course plan cards
//     setSelectedChapterId([]);
//     setSelectedChapterName("");
//     setSelectedTopicId([]);
//     setSelectedTopicName("");
//     setSelectedQuestionPaperId("");
//     setSelectedQuestionPaperName("");
//     setSelectedQuestionPaperDescription("");
//     setSelectedQuestionPaperCreatedBy("");
//     setSelectedQuestionPaperSubjects("");

//     // Reset all course plan cards to initial state
//     const resetCardData = {};
//     coursePlans.forEach((plan) => {
//       resetCardData[plan.course_plan_id] = {
//         dppName: "",
//         description: "",
//         startDate: "",
//         termDate: "",
//         folderName: "",
//         folderPath: "",
//         selectedLevel1Id: null,
//         selectedLevel2Id: null,
//         selectedLevel3Id: null,
//         isApplied: false,
//         originalData: null,
//         hasChanges: false,
//       };
//     });
//     setCoursePlanCardData(resetCardData);
//     setHasAppliedCards(false);
//   };

//   // Handle Question Paper selection with warning
//   const handleQuestionPaperChange = (selectedQPId) => {
//     // Check if any cards have been applied
//     const hasApplied = Object.values(coursePlanCardData).some(card => card.isApplied);
    
//     if (hasApplied && selectedQuestionPaperId !== selectedQPId) {
//       // Show warning with Yes/No buttons
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Changing the question paper will reload the course plan cards and may lose unsaved changes. Do you want to continue?</span>
//           </div>
//           <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//             <button
//               className="messagebox-cancel-btn-ok"
//               onClick={() => {
//                 setIsMessageBoxVisible(false);
//                 // Proceed with question paper change
//                 proceedWithQuestionPaperChange(selectedQPId);
//               }}
//             >
//               YES
//             </button>
//             <button
//               className="messagebox-cancel-btn-ok"
//               onClick={() => {
//                 setIsMessageBoxVisible(false);
//               }}
//             >
//               NO
//             </button>
//           </div>
//         </div>
//       );
//       setActiveImg(WarnningIcon);
//       return;
//     }

//     // No warning needed, proceed directly
//     proceedWithQuestionPaperChange(selectedQPId);
//   };

//   const proceedWithQuestionPaperChange = (selectedQPId) => {
//     const qpOption = Array.isArray(questionPapers)
//       ? questionPapers.find((qp) => qp.ques_paper_id === selectedQPId)
//       : undefined;
    
//     if (qpOption) {
//       setSelectedQuestionPaperId(qpOption.ques_paper_id);
//       setSelectedQuestionPaperName(qpOption.ques_paper_name);
//       setSelectedQuestionPaperDescription(qpOption.description);
//       setSelectedQuestionPaperCreatedBy(qpOption.created_by);
//       setSelectedQuestionPaperSubjects(qpOption.subject_name || "");
      
//       // Reset applied cards tracking
//       setHasAppliedCards(false);
      
//       // Reset all course plan cards to initial state
//       const resetCardData = {};
//       coursePlans.forEach((plan) => {
//         resetCardData[plan.course_plan_id] = {
//           dppName: "",
//           description: "",
//           startDate: "",
//           termDate: "",
//           folderName: "",
//           folderPath: "",
//           selectedLevel1Id: null,
//           selectedLevel2Id: null,
//           selectedLevel3Id: null,
//           isApplied: false,
//           originalData: null,
//           hasChanges: false,
//         };
//       });
//       setCoursePlanCardData(resetCardData);
//     } else {
//       setSelectedQuestionPaperId("");
//       setSelectedQuestionPaperName("");
//       setSelectedQuestionPaperDescription("");
//       setSelectedQuestionPaperCreatedBy("");
//       setSelectedQuestionPaperSubjects("");
//     }
//   };

//   const handleSave = async () => {
//     const cardsToSave = Object.entries(coursePlanCardData)
//       .filter(([_, data]) => {
//         return data.isApplied && data.hasChanges;
//       })
//       .map(([planId, data]) => ({
//         ques_paper_id: parseInt(selectedQuestionPaperId, 10),
//         dpp_name: data.dppName,
//         dpp_desc: data.description,
//         dpp_abb: "",
//         dpp_window_start: data.startDate ? new Date(data.startDate).toISOString() : null,
//         dpp_window_end: data.startDate ? new Date(data.startDate).toISOString() : null,
//         course_plan_id: parseInt(planId, 10),
//         dpp_level1_id: data.selectedLevel1Id,
//         dpp_level2_id: data.selectedLevel2Id,
//         dpp_level3_id: data.selectedLevel3Id || null,
//         subject_superset_id: selectedSubjectSupersetId ? parseInt(selectedSubjectSupersetId, 10) : null,
//         chapter_names: selectedChapterName || null,
//         topic_names: selectedTopicName || null,
//         dedicated_client_id: clientId ? parseInt(clientId, 10) : null,
//         dpp_term_date: data.termDate ? new Date(data.termDate).toISOString() : null,
//         instructions_html: instructionsHtml || null,
//         created_by: userName,
//         // Include dpp_schedule_id if it exists (for updates)
//         ...(data.dppScheduleId && { dpp_schedule_id: data.dppScheduleId }),
//       }));

//     if (cardsToSave.length === 0) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>
//               No changes to save. Please apply at least one course plan card with modifications.
//             </span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       return;
//     }

//     try {
//       const result = await POST.withToken(EndPoints.PRISM_CREATE_DPP_SCHEDULE, cardsToSave, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });

//       if (result && (result.status === 200 || result.status === 201)) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>{result.message || "DPP schedule created successfully!"}</span>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//         setActiveImg(SucessImg);

//         setTimeout(() => {
//           navigate(-1);
//         }, 1000);
//       } else if (result) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>
//                 {"Failed to save DPP Schedule: " + (result.message || "Unknown error")}
//               </span>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//         setActiveImg(ErrorImg);
//       }
//     } catch (error) {
//       console.error("Error saving DPP schedule:", error);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Error saving DPP schedule</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//     }
//   };

//   const getCurrentDateTime = () => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, "0");
//     const day = String(now.getDate()).padStart(2, "0");
//     const hours = String(now.getHours()).padStart(2, "0");
//     const minutes = String(now.getMinutes()).padStart(2, "0");
//     return `${year}-${month}-${day}T${hours}:${minutes}`;
//   };

//   // CASCADING CLEAR LOGIC

//   // When subject changes, clear chapter
//   useEffect(() => {
//     setSelectedChapterId([]);
//     setSelectedChapterName("");
//   }, [selectedSubjectIds]);

//   // When chapter changes, clear topic
//   useEffect(() => {
//     setSelectedTopicId([]);
//     setSelectedTopicName("");
//   }, [selectedChapterId]);

//   // When subject/chapter/topic changes, clear Question Paper
//   useEffect(() => {
//     setSelectedQuestionPaperId("");
//     setSelectedQuestionPaperName("");
//     setSelectedQuestionPaperDescription("");
//     setSelectedQuestionPaperCreatedBy("");
//     setSelectedQuestionPaperSubjects("");
//   }, [selectedSubjectIds, selectedChapterId, selectedTopicId]);

//   // When Question Paper is selected, fetch existing schedule
//   useEffect(() => {
//     if (selectedQuestionPaperId && coursePlans.length > 0) {
//       fetchExistingDppSchedule(selectedQuestionPaperId);
//     }
//   }, [selectedQuestionPaperId]);

//   // Helper to get other plans for copy dropdown
//   const getOtherPlans = (currentPlanId) => {
//     return coursePlans.filter((p) => p.course_plan_id !== currentPlanId);
//   };

//   // Render Course Plan Card
//   const renderCoursePlanCard = (plan) => {
//     const cardData = coursePlanCardData[plan.course_plan_id] || {
//       dppName: "",
//       description: "",
//       startDate: "",
//       termDate: "",
//       folderName: "",
//       isApplied: false,
//       hasChanges: false,
//     };

//     const isExpanded = expandedCards[plan.course_plan_id] || false;
//     const isEnabled = !!selectedQuestionPaperId;
//     const otherPlans = getOtherPlans(plan.course_plan_id);

//     const canApply =
//       !cardData.isApplied &&
//       cardData.dppName?.trim() &&
//       cardData.description?.trim() &&
//       cardData.startDate &&
//       cardData.folderName;

//     const onApplyClick = () => {
//       if (canApply) {
//         handleApplyCard(plan.course_plan_id);
//         setExpandedCards((prev) => ({
//           ...prev,
//           [plan.course_plan_id]: false,
//         }));
//       }
//     };

//     // Handle header click to minimize
//     const handleHeaderClick = (e) => {
//       if (isExpanded && isEnabled) {
//         // Don't minimize if clicking on a button or input
//         if (e.target.tagName === 'BUTTON' || e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT' || e.target.closest('.copy-icon-container')) {
//           return;
//         }
//         setExpandedCards((prev) => ({
//           ...prev,
//           [plan.course_plan_id]: false,
//         }));
//       }
//     };

//     return (
//       <div
//         key={plan.course_plan_id}
//         className="course-plan-card"
//         style={{
//           border: "1px solid var(--DppCardBorder)",
//           borderRadius: "8px",
//           marginBottom: "16px",
//           backgroundColor: isExpanded ? "var(--DppCardBackground)" : "var(--DppCardBackgroundCollapsed)",
//           boxShadow: "0px 2px 4px rgba(0,0,0,0.08)",
//           opacity: isEnabled ? 1 : 0.7,
//         }}
//       >
//         {/* Card Header */}
//         <div
//           onClick={handleHeaderClick}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             gap: "16px",
//             padding: "16px 20px",
//             backgroundColor: isExpanded ? "var(--DppCardHeaderExpanded)" : "transparent",
//             borderBottom: isExpanded ? "1px solid var(--DppCardHeaderBorder)" : "none",
//             borderRadius: isExpanded ? "8px 8px 0 0" : "8px",
//             cursor: isExpanded && isEnabled ? "pointer" : "default",
//           }}
//         >
//           {/* Left: Plan Name with Applied Checkmark and Copy Icon */}
//           <div style={{ display: "flex", alignItems: "flex-start", gap: "8px", minWidth: "200px" }}>
//             <div style={{ flex: 1 }}>
//               <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//                 <h3
//                   style={{
//                     margin: 0,
//                     color: "var(--DppPlanNameText)",
//                     fontSize: "15px",
//                     fontWeight: "600",
//                     color: "#6A6A6A"
//                   }}
//                 >
//                   {plan.plan_name}
//                 </h3>
//                 {cardData.isApplied && (
//                   <IoCheckmarkCircle 
//                     style={{ 
//                       color: "var(--DppCheckmarkColor)",
//                       fontSize: "18px",
//                       marginLeft: "2px",
//                     }}
//                   />
//                 )}
//               </div>
//               <p
//                 style={{
//                   margin: "2px 0 0 0",
//                   color: "var(--DppPlanDescText)",
//                   fontSize: "12px",
//                   color: "#6A6A6A",
//                 }}
//               >
//                 {plan.description}
//               </p>
//             </div>
            
//             {/* Copy Icon - Only show when expanded and enabled */}
//             {isExpanded && isEnabled && otherPlans.length > 0 && (
//               <div 
//                 className="copy-icon-container"
//                 style={{ 
//                   position: "relative", 
//                   marginTop: "2px",
//                 }}
//                 ref={activeCopyDropdown === plan.course_plan_id ? copyDropdownRef : null}
//               >
//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setActiveCopyDropdown(
//                       activeCopyDropdown === plan.course_plan_id ? null : plan.course_plan_id
//                     );
//                   }}
//                   style={{
//                     background: "none",
//                     border: "none",
//                     cursor: "pointer",
//                     padding: "4px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                   title="Copy from another plan"
//                 >
//                   <svg 
//                     width="20" 
//                     height="20" 
//                     viewBox="0 0 24 24" 
//                     fill="none" 
//                     stroke="currentColor" 
//                     strokeWidth="2"
//                     style={{ color: "var(--DppLabelText)" }}
//                   >
//                     <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
//                     <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
//                   </svg>
//                 </button>

//                 {/* Copy Dropdown */}
//                 {activeCopyDropdown === plan.course_plan_id && (
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: "100%",
//                       left: "0",
//                       marginTop: "4px",
//                       backgroundColor: "var(--DppDropdownBackground)",
//                       border: "1px solid var(--DppDropdownBorder)",
//                       borderRadius: "4px",
//                       boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                       zIndex: 1000,
//                       minWidth: "200px",
//                     }}
//                   >
//                     <div style={{ padding: "8px 12px", borderBottom: "1px solid var(--DppDropdownItemBorder)", fontSize: "12px", color: "var(--DppDropdownSubText)", fontWeight: "500" }}>
//                       Copy from...
//                     </div>
//                     {otherPlans.map((p) => (
//                       <div
//                         key={p.course_plan_id}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleCopyFromPlan(plan.course_plan_id, p.course_plan_id);
//                         }}
//                         style={{
//                           padding: "10px 12px",
//                           cursor: "pointer",
//                           fontSize: "13px",
//                           borderBottom: "1px solid var(--DppDropdownSearchBorder)",
//                         }}
//                         onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground)"}
//                         onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownBackground)"}
//                       >
//                         {p.plan_name}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Middle and Right: DPP Name and Folder - Only show when NOT expanded */}
//           {!isExpanded && (
//             <>
//               {/* Middle: DPP Name */}
//               <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
//                 <span style={{ color: "#6A6A6A", fontSize: "14px" }}>DPP Name</span>
//                 <span style={{ color: "#6A6A6A", fontSize: "14px" }}>▾</span>
//                 <span style={{ color: "#6A6A6A", fontSize: "14px", marginLeft: "4px" }}>
//                   {cardData.dppName || "NA"}
//                 </span>
//               </div>

//               {/* Right: Folder Path */}
//               <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
//                 <span style={{ color: "#6A6A6A", fontSize: "14px" }}>Folder</span>
//                 <span style={{ color: "#6A6A6A", fontSize: "14px" }}>▾</span>
//                 <span style={{color: "#6A6A6A", fontSize: "14px", marginLeft: "4px" }}>
//                   {cardData.folderName || "NA"}
//                 </span>
//               </div>

//               {/* Expand Arrow - Chevron style */}
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   toggleCardExpanded(plan.course_plan_id);
//                 }}
//                 disabled={!isEnabled}
//                 style={{
//                   background: "none",
//                   border: "none",
//                   cursor: isEnabled ? "pointer" : "not-allowed",
//                   padding: "4px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//                 title={isEnabled ? "Expand" : "Select a question paper to enable"}
//               >
//                 <svg 
//                   width="20" 
//                   height="20" 
//                   viewBox="0 0 24 24" 
//                   fill="none" 
//                   stroke={isEnabled ? "#333" : "#999"}
//                   strokeWidth="3"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <polyline points="6 9 12 15 18 9"></polyline>
//                 </svg>
//               </button>
//             </>
//           )}

//           {/* Collapse Arrow - Chevron style - Only show when expanded */}
//           {isExpanded && (
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 toggleCardExpanded(plan.course_plan_id);
//               }}
//               style={{
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//                 padding: "4px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//               title="Collapse"
//             >
//               <svg 
//                 width="20" 
//                 height="20" 
//                 viewBox="0 0 24 24" 
//                 fill="none" 
//                 stroke="#333"
//                 strokeWidth="3"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <polyline points="18 15 12 9 6 15"></polyline>
//               </svg>
//             </button>
//           )}
//         </div>

//         {/* Expanded View */}
//         {isExpanded && isEnabled && (
//           <div style={{ padding: "20px", backgroundColor: "var(--DppDropdownBackground)" }}>
//             {/* Row 1: DPP Name, Description, Start Date */}
//             <div style={{ 
//               display: "grid", 
//               gridTemplateColumns: "1fr 1fr 1fr", 
//               gap: "20px",
//             }}>
//               <div>
//                 <label style={{ color: "GrayText", fontSize: "14px", display: "block", marginBottom: "6px" }}>
//                   DPP Name <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={cardData.dppName}
//                   onChange={(e) =>
//                     updateCardData(plan.course_plan_id, "dppName", e.target.value)
//                   }
//                   placeholder="Enter DPP name"
//                   style={{
//                     width: "100%",
//                     padding: "10px 12px",
//                     border: "1px solid var(--DppInputBorder)",
//                     borderRadius: "4px",
//                     fontSize: "14px",
//                     boxSizing: "border-box",
//                     color: "#6A6A6A"
//                   }}
//                 />
//               </div>
//               <div>
//                 <label style={{ color: "GrayText", fontSize: "14px", display: "block", marginBottom: "6px" }}>
//                   Description <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={cardData.description}
//                   onChange={(e) =>
//                     updateCardData(plan.course_plan_id, "description", e.target.value)
//                   }
//                   placeholder="Enter Description"
//                   style={{
//                     width: "100%",
//                     padding: "10px 12px",
//                     border: "1px solid var(--DppInputBorder)",
//                     borderRadius: "4px",
//                     fontSize: "14px",
//                     boxSizing: "border-box",
//                      color: "#6A6A6A"
//                   }}
//                 />
//               </div>
//               <div>
//                 <label style={{ color: "GrayText", fontSize: "14px", display: "block", marginBottom: "6px" }}>
//                   Start Date <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="datetime-local"
//                   min={getCurrentDateTime()}
//                   value={cardData.startDate || ""}
//                   onChange={(e) =>
//                     updateCardData(plan.course_plan_id, "startDate", e.target.value)
//                   }
//                   readOnly={cardData.startDate && new Date(cardData.startDate) < new Date()}
//                   disabled={cardData.startDate && new Date(cardData.startDate) < new Date()}
//                   style={{
//                     width: "100%",
//                     padding: "10px 12px",
//                     border: "1px solid var(--DppInputBorder)",
//                     borderRadius: "4px",
//                     fontSize: "14px",
//                     color: "var(--DppInputText)",
//                     boxSizing: "border-box",
//                     color: "#6A6A6A",
//                     cursor: cardData.startDate && new Date(cardData.startDate) < new Date() ? "not-allowed" : "pointer",
//                     opacity: cardData.startDate && new Date(cardData.startDate) < new Date() ? 0.6 : 1,
//                   }}
//                 />
//               </div>
//             </div>

//             {/* Row 2: Term Date (left), Folder Name (right, spans 2 columns) */}
//             <div style={{ 
//               display: "grid", 
//               gridTemplateColumns: "1fr 1fr 1fr", 
//               gap: "20px", 
//               marginTop: "16px",
//             }}>
//               {/* Term Date - 1st column */}
//               <div style={{ gridColumn: "1 / 2" }}>
//                 <label style={{ color: "GrayText", fontSize: "14px", display: "block", marginBottom: "6px" }}>
//                   Term Date (Optional)
//                 </label>
//                 <input
//                   type="datetime-local"
//                   min={cardData.startDate || getCurrentDateTime()}
//                   value={cardData.termDate || ""}
//                   onChange={(e) =>
//                     updateCardData(plan.course_plan_id, "termDate", e.target.value)
//                   }
//                   style={{
//                     width: "100%",
//                     padding: "10px 12px",
//                     border: "1px solid var(--DppInputBorder)",
//                     borderRadius: "4px",
//                     fontSize: "14px",
//                     color: "var(--DppInputText)",
//                     boxSizing: "border-box",
//                     color: "#6A6A6A"
//                   }}
//                 />
//               </div>

//               {/* Folder Name - spans columns 2-3 */}
//               <div style={{ gridColumn: "2 / 4" }}>
//                 <label style={{ color: "GrayText", fontSize: "14px", display: "block", marginBottom: "6px" }}>
//                   Folder Name <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <div
//                   ref={activeFolderPicker === plan.course_plan_id ? folderPickerRef : null}
//                   style={{ position: "relative" }}
//                 >
//                   <input
//                     type="text"
//                     value={
//                       folderSearchText[plan.course_plan_id] !== undefined
//                         ? folderSearchText[plan.course_plan_id]
//                         : (coursePlanCardData[plan.course_plan_id]?.folderName || "")
//                     }
//                     onChange={(e) => {
//                       const searchVal = e.target.value;
//                       setFolderSearchText(prev => ({ ...prev, [plan.course_plan_id]: searchVal }));
//                       if (searchVal.trim()) {
//                         setExpandedLevel1(null);
//                         setExpandedLevel2(null);
//                         setExpandedLevel3(null);
//                       }
//                       if (!activeFolderPicker) {
//                         setActiveFolderPicker(plan.course_plan_id);
//                       }
//                     }}
//                     onFocus={() => {
//                       if (activeFolderPicker !== plan.course_plan_id) {
//                         setActiveFolderPicker(plan.course_plan_id);
//                         setFolderSearchText(prev => ({ ...prev, [plan.course_plan_id]: "" }));
//                       }
//                     }}
//                     placeholder="Select or search folder..."
//                     style={{
//                       width: "100%",
//                       padding: "10px 12px",
//                       paddingRight: "35px",
//                       border: "1px solid var(--DppInputBorder)",
//                       borderRadius: "4px",
//                       fontSize: "14px",
//                       boxSizing: "border-box",
//                       backgroundColor: "var(--DppDropdownBackground)",
//                       color: "#6A6A6A"
//                     }}
//                   />
//                   <span 
//                     onClick={() => {
//                       if (activeFolderPicker === plan.course_plan_id) {
//                         setActiveFolderPicker(null);
//                         setFolderSearchText(prev => {
//                           const newState = { ...prev };
//                           delete newState[plan.course_plan_id];
//                           return newState;
//                         });
//                         setExpandedLevel1(null);
//                         setExpandedLevel2(null);
//                         setExpandedLevel3(null);
//                       } else {
//                         setActiveFolderPicker(plan.course_plan_id);
//                         setFolderSearchText(prev => ({ ...prev, [plan.course_plan_id]: "" }));
//                       }
//                     }}
//                     style={{ 
//                       position: "absolute", 
//                       right: "12px", 
//                       top: "50%", 
//                       transform: "translateY(-50%)",
//                       color: "#6A6A6A",
//                       cursor: "pointer",
//                     }}
//                   >
//                     ▼
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Folder Picker Dropdowns - positioned to start from column 2 (33.33% from left) */}
//             {activeFolderPicker === plan.course_plan_id && folderLevelData[plan.course_plan_id] && (
//               <div ref={dropdownRef} style={{ position: "relative", zIndex: 99999, marginTop: "4px" }}>
//                 {/* Search Results Dropdown */}
//                 {folderSearchText[plan.course_plan_id]?.trim() ? (
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: "0",
//                       left: "calc(33.33% + 10px)",
//                       width: "calc(66.66% - 20px)",
//                       backgroundColor: "var(--DppDropdownBackground)",
//                       border: "1px solid var(--DppInputBorder)",
//                       borderRadius: "4px",
//                       boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                       zIndex: 99999,
//                       maxHeight: "250px",
//                       overflowY: "auto",
//                     }}
//                   >
//                     {(() => {
//                       const searchTerm = folderSearchText[plan.course_plan_id].toLowerCase();
//                       const results = [];
                      
//                       folderLevelData[plan.course_plan_id].forEach((level1) => {
//                         if (level1.level2) {
//                           level1.level2.forEach((level2) => {
//                             if (level2.name.toLowerCase().includes(searchTerm)) {
//                               results.push({
//                                 type: 'level2',
//                                 level1,
//                                 level2,
//                                 level3: null,
//                                 displayPath: `${level1.name} > ${level2.name}`,
//                               });
//                             }
//                             if (level2.level3) {
//                               level2.level3.forEach((level3) => {
//                                 if (level3.name.toLowerCase().includes(searchTerm)) {
//                                   results.push({
//                                     type: 'level3',
//                                     level1,
//                                     level2,
//                                     level3,
//                                     displayPath: `${level1.name} > ${level2.name} > ${level3.name}`,
//                                   });
//                                 }
//                               });
//                             }
//                           });
//                         }
//                       });

//                       if (results.length === 0) {
//                         return (
//                           <div style={{ padding: "12px", color: "var(--DppLabelText)", textAlign: "center" }}>
//                             No results found
//                           </div>
//                         );
//                       }

//                       return results.map((result, idx) => (
//                         <div
//                           key={idx}
//                           onClick={() => {
//                             const folderPath = result.displayPath;
//                             const planId = plan.course_plan_id;
//                             setCoursePlanCardData(prev => {
//                               const existingData = prev[planId] || {};
//                               return {
//                                 ...prev,
//                                 [planId]: {
//                                   ...existingData,
//                                   folderName: folderPath,
//                                   folderPath: folderPath,
//                                   selectedLevel1Id: result.level1.dpp_level1_id,
//                                   selectedLevel2Id: result.level2.dpp_level2_id,
//                                   selectedLevel3Id: result.level3?.dpp_level3_id || null,
//                                   isApplied: false,
//                                   hasChanges: true,
//                                 },
//                               };
//                             });
//                             setActiveFolderPicker(null);
//                             setFolderSearchText(prev => {
//                               const newState = { ...prev };
//                               delete newState[planId];
//                               return newState;
//                             });
//                             setExpandedLevel1(null);
//                             setExpandedLevel2(null);
//                             setExpandedLevel3(null);
//                           }}
//                           style={{
//                             padding: "10px 12px",
//                             cursor: "pointer",
//                             borderBottom: "1px solid var(--DppDropdownItemBorder)",
//                             color: "var(--DppValueText)",
//                             backgroundColor: "var(--DppDropdownBackground)",
//                           }}
//                           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgb(212, 237, 218)"}
//                           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
//                         >
//                           {result.displayPath}
//                         </div>
//                       ));
//                     })()}
//                   </div>
//                 ) : (
//                   /* Level 1 Dropdown - positioned from column 2 start */
//                   <div 
//                     style={{ 
//                       position: "absolute", 
//                       top: "0", 
//                       left: "calc(33.33% + 10px)",
//                       width: "220px",
//                       backgroundColor: "var(--DppDropdownBackground)",
//                       border: "1px solid var(--DppInputBorder)",
//                       borderRadius: "4px",
//                       boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                       maxHeight: "200px",
//                       overflowY: "auto",
//                       zIndex: 99999,
//                     }}
//                   >
//                     {folderLevelData[plan.course_plan_id].map((level1) => (
//                       <div
//                         key={level1.dpp_level1_id}
//                         onMouseEnter={() => {
//                           setExpandedLevel1(level1.dpp_level1_id);
//                           setExpandedLevel2(null);
//                           setExpandedLevel3(null);
//                         }}
//                         style={{
//                           padding: "10px 12px",
//                           backgroundColor: expandedLevel1 === level1.dpp_level1_id ? "rgb(212, 237, 218)" : "#fff",
//                           color: "var(--DppValueText)",
//                           cursor: "default",
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                           fontWeight: "500",
//                           borderBottom: "1px solid var(--DppDropdownItemBorder)",
//                         }}
//                       >
//                         <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level1.name}</span>
//                         {level1.level2 && level1.level2.length > 0 && (
//                           <span style={{ fontSize: "10px", marginLeft: "4px", color: "var(--DppLabelText)" }}>▶</span>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* Level 2 Dropdown */}
//                 {!folderSearchText[plan.course_plan_id]?.trim() && expandedLevel1 && (() => {
//                   const level1Data = folderLevelData[plan.course_plan_id].find(l => l.dpp_level1_id === expandedLevel1);
//                   if (!level1Data?.level2?.length) return null;
//                   return (
//                     <div
//                       style={{
//                         position: "absolute",
//                         top: "0",
//                         left: "calc(33.33% + 232px)",
//                         width: "220px",
//                         backgroundColor: "var(--DppDropdownBackground)",
//                         border: "1px solid var(--DppInputBorder)",
//                         borderRadius: "4px",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                         maxHeight: "200px",
//                         overflowY: "auto",
//                         zIndex: 100000,
//                       }}
//                     >
//                       {level1Data.level2.map((level2) => (
//                         <div
//                           key={level2.dpp_level2_id}
//                           onMouseEnter={() => {
//                             setExpandedLevel2(level2.dpp_level2_id);
//                             setExpandedLevel3(null);
//                           }}
//                           onClick={() => {
//                             const level1 = folderLevelData[plan.course_plan_id].find(l => l.dpp_level1_id === expandedLevel1);
//                             const folderPath = `${level1.name} > ${level2.name}`;
//                             const planId = plan.course_plan_id;
//                             setCoursePlanCardData(prev => {
//                               const existingData = prev[planId] || {};
//                               return {
//                                 ...prev,
//                                 [planId]: {
//                                   ...existingData,
//                                   folderName: folderPath,
//                                   folderPath: folderPath,
//                                   selectedLevel1Id: level1.dpp_level1_id,
//                                   selectedLevel2Id: level2.dpp_level2_id,
//                                   selectedLevel3Id: null,
//                                   isApplied: false,
//                                   hasChanges: true,
//                                 },
//                               };
//                             });
//                             setActiveFolderPicker(null);
//                             setFolderSearchText(prev => {
//                               const newState = { ...prev };
//                               delete newState[planId];
//                               return newState;
//                             });
//                             setExpandedLevel1(null);
//                             setExpandedLevel2(null);
//                             setExpandedLevel3(null);
//                           }}
//                           style={{
//                             padding: "10px 12px",
//                             backgroundColor: expandedLevel2 === level2.dpp_level2_id ? "rgb(212, 237, 218)" : "#fff",
//                             color: "var(--DppValueText)",
//                             cursor: "pointer",
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             borderBottom: "1px solid var(--DppDropdownItemBorder)",
//                           }}
//                         >
//                           <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level2.name}</span>
//                           {level2.level3 && level2.level3.length > 0 && (
//                             <span style={{ fontSize: "10px", color: "var(--DppLabelText)", marginLeft: "4px" }}>▶</span>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   );
//                 })()}

//                 {/* Level 3 Dropdown */}
//                 {!folderSearchText[plan.course_plan_id]?.trim() && expandedLevel2 && (() => {
//                   const level1Data = folderLevelData[plan.course_plan_id].find(l => l.dpp_level1_id === expandedLevel1);
//                   const level2Data = level1Data?.level2?.find(l => l.dpp_level2_id === expandedLevel2);
//                   if (!level2Data?.level3?.length) return null;
//                   return (
//                     <div
//                       style={{
//                         position: "absolute",
//                         top: "0",
//                         left: "calc(33.33% + 454px)",
//                         width: "220px",
//                         backgroundColor: "var(--DppDropdownBackground)",
//                         border: "1px solid var(--DppInputBorder)",
//                         borderRadius: "4px",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                         maxHeight: "200px",
//                         overflowY: "auto",
//                         zIndex: 100001,
//                       }}
//                     >
//                       {level2Data.level3.map((level3) => (
//                         <div
//                           key={level3.dpp_level3_id}
//                           onMouseEnter={() => {
//                             setExpandedLevel3(level3.dpp_level3_id);
//                           }}
//                           onClick={() => {
//                             const level1 = folderLevelData[plan.course_plan_id].find(l => l.dpp_level1_id === expandedLevel1);
//                             const level2 = level1?.level2?.find(l => l.dpp_level2_id === expandedLevel2);
//                             const folderPath = `${level1.name} > ${level2.name} > ${level3.name}`;
//                             const planId = plan.course_plan_id;
//                             setCoursePlanCardData(prev => {
//                               const existingData = prev[planId] || {};
//                               return {
//                                 ...prev,
//                                 [planId]: {
//                                   ...existingData,
//                                   folderName: folderPath,
//                                   folderPath: folderPath,
//                                   selectedLevel1Id: level1.dpp_level1_id,
//                                   selectedLevel2Id: level2.dpp_level2_id,
//                                   selectedLevel3Id: level3.dpp_level3_id,
//                                   isApplied: false,
//                                   hasChanges: true,
//                                 },
//                               };
//                             });
//                             setActiveFolderPicker(null);
//                             setFolderSearchText(prev => {
//                               const newState = { ...prev };
//                               delete newState[planId];
//                               return newState;
//                             });
//                             setExpandedLevel1(null);
//                             setExpandedLevel2(null);
//                             setExpandedLevel3(null);
//                           }}
//                           style={{
//                             padding: "10px 12px",
//                             backgroundColor: expandedLevel3 === level3.dpp_level3_id ? "rgb(212, 237, 218)" : "#fff",
//                             color: "var(--DppValueText)",
//                             cursor: "pointer",
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             borderBottom: "1px solid var(--DppDropdownItemBorder)",
//                           }}
//                         >
//                           <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level3.name}</span>
//                           {level3.dpp_sets && level3.dpp_sets.length > 0 && (
//                             <span style={{ fontSize: "10px", color: "var(--DppLabelText)", marginLeft: "4px" }}>▶</span>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   );
//                 })()}

//                 {/* Level 4 (dpp_sets) Dropdown */}
//                 {!folderSearchText[plan.course_plan_id]?.trim() && expandedLevel3 && (() => {
//                   const level1Data = folderLevelData[plan.course_plan_id].find(l => l.dpp_level1_id === expandedLevel1);
//                   const level2Data = level1Data?.level2?.find(l => l.dpp_level2_id === expandedLevel2);
//                   const level3Data = level2Data?.level3?.find(l => l.dpp_level3_id === expandedLevel3);
//                   if (!level3Data?.dpp_sets?.length) return null;
//                   return (
//                     <div
//                       style={{
//                         position: "absolute",
//                         top: "0",
//                         left: "calc(33.33% + 676px)",
//                         width: "220px",
//                         backgroundColor: "var(--DppDropdownBackground)",
//                         border: "1px solid var(--DppInputBorder)",
//                         borderRadius: "4px",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                         maxHeight: "200px",
//                         overflowY: "auto",
//                         zIndex: 100002,
//                       }}
//                     >
//                       {level3Data.dpp_sets.map((dppSet) => (
//                         <div
//                           key={dppSet.dpp_schedule_id}
//                           style={{
//                             padding: "10px 12px",
//                             backgroundColor: "var(--DppDropdownLevel4Background)",
//                             color: "var(--DppValueText)",
//                             cursor: "default",
//                             borderBottom: "1px solid var(--DppDropdownItemBorder)",
//                           }}
//                         >
//                           <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dppSet.dpp_set_name}</span>
//                         </div>
//                       ))}
//                     </div>
//                   );
//                 })()}
//               </div>
//             )}

//             {/* Card Footer - Action Buttons */}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 gap: "12px",
//                 marginTop: "20px",
//                 paddingTop: "16px",
//                 borderTop: "1px solid var(--DppSectionBorder)",
//               }}
//             >
//               <button
//                 onClick={() => handleResetCard(plan.course_plan_id)}
//                 style={{
//                   backgroundColor: "var(--DppButtonResetBackground)",
//                   color: "var(--DppButtonResetText)",
//                   border: "1px solid var(--DppButtonResetBorder)",
//                   borderRadius: "4px",
//                   padding: "10px 32px",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                   cursor: "pointer",
//                 }}
//               >
//                 RESET
//               </button>
//               <button
//                 onClick={onApplyClick}
//                 disabled={!canApply}
//                 style={{
//                   backgroundColor: canApply ? "var(--DppButtonApplyBackground)" : "var(--DppButtonApplyBackgroundDisabled)",
//                   color: "var(--DppButtonApplyText)",
//                   border: "none",
//                   borderRadius: "4px",
//                   padding: "10px 32px",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                   cursor: canApply ? "pointer" : "not-allowed",
//                 }}
//               >
//                 APPLY
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="Leftmargin-Main-DIV">
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             marginBottom: "20px",
//             width: "98%",
//           }}
//         >
//           <div
//             style={{
//               fontSize: "30px",
//               color: `${Colors.color1}`,
//               fontWeight: "400",
//             }}
//           >
//             DPP Scheduling
//           </div>
//           <div>
//             <div className="row-cs-uni">
//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "18px",
//                   boxShadow: "0px 4px 4px 0px #00000040",
//                 }}
//                 onClick={() => navigate(-1)}
//               >
//                 CANCEL
//               </button>
//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "0px",
//                   boxShadow: "0px 4px 4px 0px #00000040",
//                 }}
//                 onClick={handleSave}
//               >
//                 SAVE
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* QUESTION PAPER DETAIL Section */}
//         <div className="Header-1-C424342">QUESTION PAPER DETAIL</div>
//         <div className="Body-1-C424342">
//           {/* Row 1: Course, Subject, Chapter */}
//           <div className="row-cs">
//             <div className="col-cs">
//               <DropDown
//                 label="Select Course"
//                 style={{ width: "97%" }}
//                 setSelected={handleCourseChange}
//                 options={courses.map((course) => ({
//                   label: course.course_name,
//                   id: course.course_id,
//                 }))}
//               />
//             </div>
//             <div className="col-cs">
//               <DropDown
//                 key={`subject-${selectedCourseId}`}
//                 label="Select Subject"
//                 style={{ width: "97%" }}
//                 value={selectedSubjectSupersetId}
//                 setSelected={(selectedSupersetId) => {
//                   // Check if question paper is selected and any cards have been applied
//                   const hasApplied = selectedQuestionPaperId && Object.values(coursePlanCardData).some(card => card.isApplied);
                  
//                   if (hasApplied && selectedSubjectSupersetId !== selectedSupersetId) {
//                     // Show warning with Yes/No buttons
//                     setIsMessageBoxVisible(true);
//                     setMessageBox(
//                       <div className="Container-messageBOX">
//                         <div className="messagebox-insider1">
//                           <span>Changing the subject will reset the question paper selection and all applied course plan cards. Do you want to continue?</span>
//                         </div>
//                         <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//                           <button
//                             className="messagebox-cancel-btn-ok"
//                             onClick={() => {
//                               setIsMessageBoxVisible(false);
//                               // Proceed with subject change
//                               proceedWithSubjectChange(selectedSupersetId);
//                             }}
//                           >
//                             YES
//                           </button>
//                           <button
//                             className="messagebox-cancel-btn-ok"
//                             onClick={() => {
//                               setIsMessageBoxVisible(false);
//                             }}
//                           >
//                             NO
//                           </button>
//                         </div>
//                       </div>
//                     );
//                     setActiveImg(WarnningIcon);
//                     return;
//                   }

//                   // No warning needed, proceed directly
//                   proceedWithSubjectChange(selectedSupersetId);
//                 }}
//                 options={(() => {
//                   // Group subjects by subject_superset_id and show unique supersets
//                   const supersetMap = new Map();
//                   if (Array.isArray(subjects)) {
//                     subjects.forEach((subject) => {
//                       if (!supersetMap.has(subject.subject_superset_id)) {
//                         supersetMap.set(subject.subject_superset_id, {
//                           label: subject.subject_superset_name,
//                           id: subject.subject_superset_id,
//                         });
//                       }
//                     });
//                   }
//                   return Array.from(supersetMap.values());
//                 })()}
//               />
//             </div>
//             <div className="col-cs">
//               <MultiSelectSearchDropdown
//                 label="Select Chapter (Optional)"
//                 width="97%"
//                 selected={selectedChapterId}
//                 setSelected={(selectedIds) => {
//                   setSelectedChapterId(selectedIds);
//                   if (Array.isArray(selectedIds) && selectedIds.length > 0) {
//                     const selectedChapters = chapters.filter((chapter) =>
//                       selectedIds.includes(chapter.chapter_id)
//                     );
//                     const names = selectedChapters
//                       .map((chapter) => chapter.chapter_name)
//                       .join(", ");
//                     setSelectedChapterName(names);
//                   } else {
//                     setSelectedChapterName("");
//                   }
//                 }}
//                 options={chapters.map((chapter) => ({
//                   label: chapter.chapter_name,
//                   id: chapter.chapter_id,
//                 }))}
//               />
//             </div>
//           </div>

//           {/* Row 2: Topic, Question Paper Name, Question Paper Description */}
//           <div className="row-cs">
//             <div className="col-cs">
//               <MultiSelectSearchDropdown
//                 label="Select Topic (Optional)"
//                 width="97%"
//                 selected={selectedTopicId}
//                 setSelected={(selectedIds) => {
//                   setSelectedTopicId(selectedIds);
//                   if (Array.isArray(selectedIds) && selectedIds.length > 0) {
//                     const selectedTopics = Array.isArray(topics)
//                       ? topics.filter((topic) =>
//                           selectedIds.includes(topic.topic_id)
//                         )
//                       : [];
//                     const names = selectedTopics
//                       .map((topic) => topic.topic_name)
//                       .join(", ");
//                     setSelectedTopicName(names);
//                   } else {
//                     setSelectedTopicName("");
//                   }
//                 }}
//                 options={
//                   Array.isArray(topics)
//                     ? topics.map((topic) => ({
//                         label: topic.topic_name,
//                         id: topic.topic_id,
//                       }))
//                     : []
//                 }
//                 isRequired={false}
//               />
//             </div>
//             <div className="col-cs">
//               <DropDown
//                 key={`qp-${selectedSubjectIds.join('-')}-${selectedChapterId?.join("-")}-${selectedTopicId?.join("-")}`}
//                 label="Question Paper Name"
//                 style={{ width: "97%" }}
//                 setSelected={handleQuestionPaperChange}
//                 options={questionPapers.map((qp) => ({
//                   label: qp.ques_paper_name,
//                   id: qp.ques_paper_id,
//                 }))}
//               />
//             </div>
//             <div className="col-cs">
//               <InputComponent
//                 label="Question Paper Description"
//                 style={{ width: "97%" }}
//                 value={selectedQuestionPaperDescription}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//           </div>

//           {/* Row 3: Question Paper Created By, Question Paper Subjects */}
//           <div className="row-cs">
//             <div className="col-cs">
//               <InputComponent
//                 label="Question Paper Created By"
//                 style={{ width: "97%" }}
//                 value={selectedQuestionPaperCreatedBy}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               <InputComponent
//                 label="Question Paper Subjects"
//                 style={{ width: "97%" }}
//                 value={selectedQuestionPaperSubjects}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               {/* Empty placeholder for alignment */}
//             </div>
//           </div>

//           {/* Instructions Editor */}
//           <div style={{ marginRight: "15px", marginBottom: "20px" }}>
//             <TextEditor
//               templates={testTemplates}
//               value={instructionsHtml}
//               setValue={setInstructionsHtml}
//             />
//           </div>
//         </div>

//         {/* COURSE PLAN CARDS Section - Show header and cards together */}
//         {selectedCourseId && coursePlans.length > 0 && (
//           <div style={{ marginTop: "30px" }}>
//             <div style={{ 
//               fontSize: "15px", 
//               fontWeight: "600", 
//               color: "var(--DppPlanNameText)",
//               marginBottom: "16px",
//               color: "#6A6A6A",
//               fontFamily: "'ABeeZee', sans-serif",                                         
//               lineHeight: "14px",   
//             }}>
//               COURSE PLAN DETAILS
//             </div>
//             <div style={{ width: "98%" }}>
//               {coursePlans.map((plan) => renderCoursePlanCard(plan))}
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default DppScheduling;























import React, { useState, useEffect, useRef } from "react";
import "./DppScheduling.css";
import DropDown from "./DropdwonClassic";
import InputComponent from "../TestScheduling/Input-testscheduling";
import TextEditor from "./TextEditor";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import SucessImg from "../../../Assets/Images/CommanImages/success.png";
import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import MultiSelectSearchDropdown from "./MultiDropdownClassic";
import { useLocation } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import { POST } from "../../../Api/HttpsMethods";
import { GET } from "../../../Api/HttpsMethods";
import EndPoints from "../../../Api/Endpoints";
import { useNavigate } from "react-router-dom";
import Colors from "../../../Constants/Colors";

const DppScheduling = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
}) => {
  const location = useLocation();
  const dppData = location.state;
  const navigate = useNavigate();

  console.log(dppData?.dpp_name);

  useEffect(() => {
    if (dataClient) {
      const userName =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const clientBranchId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", clientBranchId);
      sessionStorage.setItem("clientId", clientId);
    }
  }, [dataClient]);

  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";

  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;

  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    sessionStorage.getItem("clientId") ||
    null;

  const [selectedQuestionPaperSubjects, setSelectedQuestionPaperSubjects] =
    useState("");

  const [selectedChapterId, setSelectedChapterId] = useState([]);
  const [selectedChapterName, setSelectedChapterName] = useState("");
  const [selectedTopicId, setSelectedTopicId] = useState([]);
  const [selectedTopicName, setSelectedTopicName] = useState("");
  const [instructionsHtml, setInstructionsHtml] = useState("");
  const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
  const [selectedQuestionPaperName, setSelectedQuestionPaperName] =
    useState("");
  const [
    selectedQuestionPaperDescription,
    setSelectedQuestionPaperDescription,
  ] = useState("");
  const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] =
    useState("");
  const [testTemplates, setTestTemplates] = useState([]);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [questionPapers, setQuestionPapers] = useState([]);

  // Separate states for course id and course name
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedCourseName, setSelectedCourseName] = useState("");

  // States for subject id and subject name
  const [selectedSubjectSupersetId, setSelectedSubjectSupersetId] = useState("");
  const [selectedSubjectSupersetName, setSelectedSubjectSupersetName] = useState("");
  const [selectedSubjectIds, setSelectedSubjectIds] = useState([]);

  // Course Plans state
  const [coursePlans, setCoursePlans] = useState([]);
  const [coursePlanCardData, setCoursePlanCardData] = useState({});
  const [expandedCards, setExpandedCards] = useState({});

  // Folder picker states
  const [folderLevelData, setFolderLevelData] = useState({});
  const [activeFolderPicker, setActiveFolderPicker] = useState(null);
  const [expandedLevel1, setExpandedLevel1] = useState(null);
  const [expandedLevel2, setExpandedLevel2] = useState(null);
  const [folderSearchText, setFolderSearchText] = useState({});
  const folderPickerRef = useRef(null);
  const dropdownRef = useRef(null);

  // Track if cards have been applied
  const [hasAppliedCards, setHasAppliedCards] = useState(false);

  // Track active copy dropdown
  const [activeCopyDropdown, setActiveCopyDropdown] = useState(null);
  const copyDropdownRef = useRef(null);

  // Close folder picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        activeFolderPicker &&
        folderPickerRef.current &&
        !folderPickerRef.current.contains(event.target) &&
        (!dropdownRef.current || !dropdownRef.current.contains(event.target))
      ) {
        setActiveFolderPicker(null);
        setExpandedLevel1(null);
        setExpandedLevel2(null);
        setFolderSearchText({});
      }

      if (
        activeCopyDropdown &&
        copyDropdownRef.current &&
        !copyDropdownRef.current.contains(event.target)
      ) {
        setActiveCopyDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeFolderPicker, activeCopyDropdown]);

  // Fetch Course Plans when course is selected
  useEffect(() => {
    const fetchCoursePlans = async () => {
      if (!selectedCourseId) {
        setCoursePlans([]);
        return;
      }

      try {
        const API_ENDPOINT = `${EndPoints.PRISM_GET_COURSE_PLAN}?course_id=${selectedCourseId}`;
        const result = await GET.withToken(API_ENDPOINT);

        if (result?.status === 200 && Array.isArray(result.data)) {
          setCoursePlans(result.data);

          const initialData = {};
          const initialExpanded = {};
          result.data.forEach((plan) => {
            initialData[plan.course_plan_id] = {
              dppName: "",
              description: "",
              startDate: "",
              termDate: "",
              folderName: "",
              folderPath: "",
              selectedLevel1Id: null,
              selectedLevel2Id: null,
              selectedLevel3Id: null,
              isApplied: false,
              originalData: null,
              hasChanges: false,
            };
            initialExpanded[plan.course_plan_id] = false;
          });
          setCoursePlanCardData(initialData);
          setExpandedCards(initialExpanded);

          result.data.forEach((plan) => {
            fetchFolderLevels(plan.course_plan_id);
          });
        } else {
          setCoursePlans([]);
        }
      } catch (error) {
        console.error("Error fetching course plans:", error);
        setCoursePlans([]);
      }
    };
    fetchCoursePlans();
  }, [selectedCourseId]);

  // Fetch folder level data for a specific course plan
  const fetchFolderLevels = async (coursePlanId) => {
    try {
      const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_FOLDER_STRUCTURE}?course_plan_id=${coursePlanId}`;
      const result = await GET.withToken(API_ENDPOINT);

      if (result?.status === 200 && Array.isArray(result.data)) {
        setFolderLevelData((prev) => ({
          ...prev,
          [coursePlanId]: result.data,
        }));
      }
    } catch (error) {
      console.error("Error fetching folder levels:", error);
    }
  };

  // Fetch existing DPP schedule when question paper is selected
  const fetchExistingDppSchedule = async (quesPaperId) => {
    try {
      const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_SCHEDULE_BY_QUES_PAPER_ID}?ques_paper_id=${quesPaperId}`;
      const result = await GET.withToken(API_ENDPOINT);

      if (result?.status === 200 && Array.isArray(result.data) && result.data.length > 0) {
        const updatedCardData = { ...coursePlanCardData };
        const updatedExpanded = { ...expandedCards };

        result.data.forEach((schedule) => {
          const planId = schedule.course_plan_id;
          if (updatedCardData[planId]) {
            let folderPath = "";
            const levelData = folderLevelData[planId];
            if (levelData && schedule.dpp_level1_id) {
              const level1 = levelData.find(l => l.dpp_level1_id === schedule.dpp_level1_id);
              if (level1) {
                folderPath = level1.name;
                if (schedule.dpp_level2_id && level1.level2) {
                  const level2 = level1.level2.find(l => l.dpp_level2_id === schedule.dpp_level2_id);
                  if (level2) {
                    folderPath += ` > ${level2.name}`;
                    if (schedule.dpp_level3_id && level2.level3) {
                      const level3 = level2.level3.find(l => l.dpp_level3_id === schedule.dpp_level3_id);
                      if (level3) {
                        folderPath += ` > ${level3.name}`;
                      }
                    }
                  }
                }
              }
            }

            updatedCardData[planId] = {
              dppScheduleId: schedule.dpp_schedule_id,
              dppName: schedule.dpp_name || "",
              description: schedule.dpp_desc || "",
              startDate: schedule.dpp_window_start ? schedule.dpp_window_start.replace(" ", "T").slice(0, 16) : "",
              termDate: schedule.dpp_term_date ? schedule.dpp_term_date.replace(" ", "T").slice(0, 16) : "",
              folderName: folderPath,
              folderPath: folderPath,
              selectedLevel1Id: schedule.dpp_level1_id,
              selectedLevel2Id: schedule.dpp_level2_id,
              selectedLevel3Id: schedule.dpp_level3_id,
              isApplied: true,
              originalData: { ...schedule, folderPath },
              hasChanges: false,
            };
            updatedExpanded[planId] = true;
          }
        });

        setCoursePlanCardData(updatedCardData);
        setExpandedCards(updatedExpanded);
      }
    } catch (error) {
      console.error("Error fetching existing DPP schedule:", error);
    }
  };

  useEffect(() => {
    if (!userName || !clientBranchId) return;

    const fetchTestTemplates = async () => {
      try {
        const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_INSTRUCTIONS_TEMPLATE_LIST}?username=${userName}&branch_id=${clientBranchId}`;
        const data = await GET.withToken(API_ENDPOINT);

        if (data && data.status === 200 && Array.isArray(data.data)) {
          setTestTemplates(data.data);
        } else if (data && Array.isArray(data)) {
          setTestTemplates(data);
        }
      } catch (error) {
        console.error("Error fetching test templates:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching test templates: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };
    fetchTestTemplates();
  }, [userName, clientBranchId]);

  // Fetch Courses
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const data = await GET.withToken(EndPoints.PRISM_GET_COURSES);
        if (data) {
          setCourses(data);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <span>Error fetching courses: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };
    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchSubjects = async () => {
      if (!selectedCourseId) return;
      try {
        const API_ENDPOINT = `${EndPoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourseId}`;
        const data = await GET.withToken(API_ENDPOINT);
        if (data) setSubjects(data);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };
    fetchSubjects();
  }, [selectedCourseId]);

  useEffect(() => {
    const fetchChapters = async () => {
      if (!selectedSubjectIds || selectedSubjectIds.length === 0) return;
      try {
        const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${selectedSubjectIds.join('&subject_superset_id=')}`;
        const data = await GET.withToken(API_ENDPOINT);
        if (data) setChapters(data);
      } catch (error) {
        console.error("Error fetching chapters:", error);
      }
    };
    fetchChapters();
  }, [selectedSubjectIds]);

  useEffect(() => {
    const fetchTopics = async () => {
      if (
        !selectedChapterId ||
        !Array.isArray(selectedChapterId) ||
        selectedChapterId.length === 0
      ) {
        setTopics([]);
        return;
      }
      const data = await POST.withToken(
        EndPoints.PRISM_GET_TOPICS_BY_CHAPTER_LIST,
        selectedChapterId,
        { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
      );
      if (data && data.status_code === 200 && Array.isArray(data.data)) {
        setTopics(data.data);
      } else {
        setTopics([]);
      }
    };
    fetchTopics();
  }, [selectedChapterId]);

  // Fetch Question Papers
  useEffect(() => {
    const fetchQuestionPapers = async () => {
      if (!selectedSubjectIds || selectedSubjectIds.length === 0) {
        setQuestionPapers([]);
        return;
      }

      try {
        let API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_QUESTION_PAPER}?`;

        selectedSubjectIds.forEach((id) => {
          API_ENDPOINT += `subject_superset_ids=${id}&`;
        });

        if (Array.isArray(selectedChapterId) && selectedChapterId.length > 0) {
          selectedChapterId.forEach((id) => {
            API_ENDPOINT += `chapter_id=${id}&`;
          });
        }

        if (Array.isArray(selectedTopicId) && selectedTopicId.length > 0) {
          selectedTopicId.forEach((id) => {
            API_ENDPOINT += `topic_id=${id}&`;
          });
        }

        API_ENDPOINT = API_ENDPOINT.replace(/[&?]$/, '');

        const result = await GET.withToken(API_ENDPOINT);

        if (result?.status === 200 && Array.isArray(result.data)) {
          setQuestionPapers(result.data);
        } else {
          setQuestionPapers([]);
        }
      } catch (error) {
        console.error("Error fetching question papers:", error);
        setQuestionPapers([]);
      }
    };

    fetchQuestionPapers();
  }, [selectedSubjectIds, selectedChapterId, selectedTopicId]);

  // Helper function to update card data
  const updateCardData = (planId, field, value) => {
    setCoursePlanCardData((prev) => {
      const currentData = prev[planId] || {};
      const newData = {
        ...currentData,
        [field]: value,
        isApplied: false,
        hasChanges: true,
      };

      return {
        ...prev,
        [planId]: newData,
      };
    });
  };

  // Handle APPLY button click for a card
  const handleApplyCard = (planId) => {
    const cardData = coursePlanCardData[planId];

    if (
      !cardData.dppName?.trim() ||
      !cardData.description?.trim() ||
      !cardData.startDate ||
      !cardData.folderName
    ) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>
              Please fill all required fields: DPP Name, Description, Start Date, and Folder Name.
            </span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    const currentSnapshot = {
      dpp_name: cardData.dppName,
      dpp_desc: cardData.description,
      dpp_window_start: cardData.startDate,
      dpp_term_date: cardData.termDate,
      folderPath: cardData.folderName,
      dpp_level1_id: cardData.selectedLevel1Id,
      dpp_level2_id: cardData.selectedLevel2Id,
      dpp_level3_id: cardData.selectedLevel3Id,
      dpp_schedule_id: cardData.originalData?.dpp_schedule_id
    };

    setCoursePlanCardData((prev) => ({
      ...prev,
      [planId]: {
        ...prev[planId],
        isApplied: true,
        originalData: currentSnapshot,
        hasChanges: true,
      },
    }));

    setHasAppliedCards(true);
  };

  // Handle RESET button click for a card
  const handleResetCard = (planId) => {
    const original = coursePlanCardData[planId]?.originalData;

    if (original) {
      let folderPath = original.folderPath || "";

      setCoursePlanCardData((prev) => ({
        ...prev,
        [planId]: {
          ...prev[planId],
          dppName: original.dpp_name || "",
          description: original.dpp_desc || "",
          startDate: original.dpp_window_start?.replace(" ", "T").slice(0, 16) || "",
          termDate: original.dpp_term_date?.replace(" ", "T").slice(0, 16) || "",
          folderName: folderPath,
          folderPath: folderPath,
          selectedLevel1Id: original.dpp_level1_id,
          selectedLevel2Id: original.dpp_level2_id,
          selectedLevel3Id: original.dpp_level3_id,
          isApplied: true,
          hasChanges: false,
        },
      }));
    } else {
      setCoursePlanCardData((prev) => ({
        ...prev,
        [planId]: {
          dppName: "",
          description: "",
          startDate: "",
          termDate: "",
          folderName: "",
          folderPath: "",
          selectedLevel1Id: null,
          selectedLevel2Id: null,
          selectedLevel3Id: null,
          isApplied: false,
          originalData: null,
          hasChanges: false,
        },
      }));
    }
  };

  // Handle COPY from another plan
  const handleCopyFromPlan = (targetPlanId, sourcePlanId) => {
    if (!sourcePlanId || sourcePlanId === targetPlanId) return;
    const sourceData = coursePlanCardData[sourcePlanId];
    if (sourceData) {
      setCoursePlanCardData((prev) => ({
        ...prev,
        [targetPlanId]: {
          ...prev[targetPlanId],
          dppName: sourceData.dppName,
          description: sourceData.description,
          startDate: sourceData.startDate,
          termDate: sourceData.termDate,
          folderName: sourceData.folderName,
          folderPath: sourceData.folderPath,
          selectedLevel1Id: sourceData.selectedLevel1Id,
          selectedLevel2Id: sourceData.selectedLevel2Id,
          selectedLevel3Id: sourceData.selectedLevel3Id,
          isApplied: false,
          hasChanges: true,
        },
      }));
      setActiveCopyDropdown(null);
    }
  };

  // Toggle card expanded state
  const toggleCardExpanded = (planId) => {
    if (!selectedQuestionPaperId) return;
    setExpandedCards((prev) => ({
      ...prev,
      [planId]: !prev[planId],
    }));
  };

  // Handle Course selection with warning
  const handleCourseChange = (selectedId) => {
    const hasFilledCards = Object.values(coursePlanCardData).some(
      card => card.dppName || card.description || card.startDate || card.folderName
    );

    if (hasFilledCards && selectedCourseId !== selectedId) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Changing the course will reset all fields and course plan cards. You may lose unsaved data. Do you want to continue?</span>
          </div>
          <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
                proceedWithCourseChange(selectedId);
              }}
            >
              YES
            </button>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
              }}
            >
              NO
            </button>
          </div>
        </div>
      );
      setActiveImg(WarnningIcon);
      return;
    }

    proceedWithCourseChange(selectedId);
  };

  const proceedWithCourseChange = (selectedId) => {
    setSelectedCourseId(selectedId);
    const course = courses.find((c) => c.course_id === selectedId);
    setSelectedCourseName(course?.course_name || "");

    setSelectedSubjectSupersetId("");
    setSelectedSubjectSupersetName("");
    setSelectedSubjectIds([]);
    setSelectedChapterId([]);
    setSelectedChapterName("");
    setSelectedTopicId([]);
    setSelectedTopicName("");
    setSelectedQuestionPaperId("");
    setSelectedQuestionPaperName("");
    setSelectedQuestionPaperDescription("");
    setSelectedQuestionPaperCreatedBy("");
    setSelectedQuestionPaperSubjects("");

    setHasAppliedCards(false);
  };

  const proceedWithSubjectChange = (selectedSupersetId) => {
    const matchingSubjects = Array.isArray(subjects)
      ? subjects.filter(
          (subject) => subject.subject_superset_id === selectedSupersetId
        )
      : [];

    if (matchingSubjects.length > 0) {
      setSelectedSubjectSupersetId(selectedSupersetId);
      setSelectedSubjectSupersetName(matchingSubjects[0].subject_superset_name);
      const subjectIds = matchingSubjects.map(s => s.subject_id);
      setSelectedSubjectIds(subjectIds);
    } else {
      setSelectedSubjectSupersetId("");
      setSelectedSubjectSupersetName("");
      setSelectedSubjectIds([]);
    }

    setSelectedChapterId([]);
    setSelectedChapterName("");
    setSelectedTopicId([]);
    setSelectedTopicName("");
    setSelectedQuestionPaperId("");
    setSelectedQuestionPaperName("");
    setSelectedQuestionPaperDescription("");
    setSelectedQuestionPaperCreatedBy("");
    setSelectedQuestionPaperSubjects("");

    const resetCardData = {};
    coursePlans.forEach((plan) => {
      resetCardData[plan.course_plan_id] = {
        dppName: "",
        description: "",
        startDate: "",
        termDate: "",
        folderName: "",
        folderPath: "",
        selectedLevel1Id: null,
        selectedLevel2Id: null,
        selectedLevel3Id: null,
        isApplied: false,
        originalData: null,
        hasChanges: false,
      };
    });
    setCoursePlanCardData(resetCardData);
    setHasAppliedCards(false);
  };

  // Handle Question Paper selection with warning
  const handleQuestionPaperChange = (selectedQPId) => {
    const hasApplied = Object.values(coursePlanCardData).some(card => card.isApplied);

    if (hasApplied && selectedQuestionPaperId !== selectedQPId) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Changing the question paper will reload the course plan cards and may lose unsaved changes. Do you want to continue?</span>
          </div>
          <div className="messagebox-insider2" style={{ display: "flex", gap: "10px" }}>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
                proceedWithQuestionPaperChange(selectedQPId);
              }}
            >
              YES
            </button>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
              }}
            >
              NO
            </button>
          </div>
        </div>
      );
      setActiveImg(WarnningIcon);
      return;
    }

    proceedWithQuestionPaperChange(selectedQPId);
  };

  const proceedWithQuestionPaperChange = (selectedQPId) => {
    const qpOption = Array.isArray(questionPapers)
      ? questionPapers.find((qp) => qp.ques_paper_id === selectedQPId)
      : undefined;

    if (qpOption) {
      setSelectedQuestionPaperId(qpOption.ques_paper_id);
      setSelectedQuestionPaperName(qpOption.ques_paper_name);
      setSelectedQuestionPaperDescription(qpOption.description);
      setSelectedQuestionPaperCreatedBy(qpOption.created_by);
      setSelectedQuestionPaperSubjects(qpOption.subject_name || "");

      setHasAppliedCards(false);

      const resetCardData = {};
      coursePlans.forEach((plan) => {
        resetCardData[plan.course_plan_id] = {
          dppName: "",
          description: "",
          startDate: "",
          termDate: "",
          folderName: "",
          folderPath: "",
          selectedLevel1Id: null,
          selectedLevel2Id: null,
          selectedLevel3Id: null,
          isApplied: false,
          originalData: null,
          hasChanges: false,
        };
      });
      setCoursePlanCardData(resetCardData);
    } else {
      setSelectedQuestionPaperId("");
      setSelectedQuestionPaperName("");
      setSelectedQuestionPaperDescription("");
      setSelectedQuestionPaperCreatedBy("");
      setSelectedQuestionPaperSubjects("");
    }
  };

  const handleSave = async () => {
    const cardsToSave = Object.entries(coursePlanCardData)
      .filter(([_, data]) => {
        return data.isApplied && data.hasChanges;
      })
      .map(([planId, data]) => ({
        ques_paper_id: parseInt(selectedQuestionPaperId, 10),
        dpp_name: data.dppName,
        dpp_desc: data.description,
        dpp_abb: "",
        dpp_window_start: data.startDate ? new Date(data.startDate).toISOString() : null,
        dpp_window_end: data.startDate ? new Date(data.startDate).toISOString() : null,
        course_plan_id: parseInt(planId, 10),
        dpp_level1_id: data.selectedLevel1Id,
        dpp_level2_id: data.selectedLevel2Id,
        dpp_level3_id: data.selectedLevel3Id || null,
        subject_superset_id: selectedSubjectSupersetId ? parseInt(selectedSubjectSupersetId, 10) : null,
        chapter_names: selectedChapterName || null,
        topic_names: selectedTopicName || null,
        dedicated_client_id: clientId ? parseInt(clientId, 10) : null,
        dpp_term_date: data.termDate ? new Date(data.termDate).toISOString() : null,
        instructions_html: instructionsHtml || null,
        created_by: userName,
        ...(data.dppScheduleId && { dpp_schedule_id: data.dppScheduleId }),
      }));

    if (cardsToSave.length === 0) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>
              No changes to save. Please apply at least one course plan card with modifications.
            </span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    try {
      const result = await POST.withToken(EndPoints.PRISM_CREATE_DPP_SCHEDULE, cardsToSave, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });

      if (result && (result.status === 200 || result.status === 201)) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>{result.message || "DPP schedule created successfully!"}</span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(SucessImg);

        setTimeout(() => {
          navigate(-1);
        }, 1000);
      } else if (result) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>
                {"Failed to save DPP Schedule: " + (result.message || "Unknown error")}
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
      }
    } catch (error) {
      console.error("Error saving DPP schedule:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Error saving DPP schedule</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
    }
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  // CASCADING CLEAR LOGIC

  useEffect(() => {
    setSelectedChapterId([]);
    setSelectedChapterName("");
  }, [selectedSubjectIds]);

  useEffect(() => {
    setSelectedTopicId([]);
    setSelectedTopicName("");
  }, [selectedChapterId]);

  useEffect(() => {
    setSelectedQuestionPaperId("");
    setSelectedQuestionPaperName("");
    setSelectedQuestionPaperDescription("");
    setSelectedQuestionPaperCreatedBy("");
    setSelectedQuestionPaperSubjects("");
  }, [selectedSubjectIds, selectedChapterId, selectedTopicId]);

  useEffect(() => {
    if (selectedQuestionPaperId && coursePlans.length > 0) {
      fetchExistingDppSchedule(selectedQuestionPaperId);
    }
  }, [selectedQuestionPaperId]);

  const getOtherPlans = (currentPlanId) => {
    return coursePlans.filter((p) => p.course_plan_id !== currentPlanId);
  };

  // Render Course Plan Card
  const renderCoursePlanCard = (plan) => {
    const cardData = coursePlanCardData[plan.course_plan_id] || {
      dppName: "",
      description: "",
      startDate: "",
      termDate: "",
      folderName: "",
      isApplied: false,
      hasChanges: false,
    };

    const isExpanded = expandedCards[plan.course_plan_id] || false;
    const isEnabled = !!selectedQuestionPaperId;
    const otherPlans = getOtherPlans(plan.course_plan_id);

    const canApply =
      !cardData.isApplied &&
      cardData.dppName?.trim() &&
      cardData.description?.trim() &&
      cardData.startDate &&
      cardData.folderName;

    const onApplyClick = () => {
      if (canApply) {
        handleApplyCard(plan.course_plan_id);
        setExpandedCards((prev) => ({
          ...prev,
          [plan.course_plan_id]: false,
        }));
      }
    };

    const handleHeaderClick = (e) => {
      if (isExpanded && isEnabled) {
        if (e.target.tagName === 'BUTTON' || e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT' || e.target.closest('.copy-icon-container')) {
          return;
        }
        setExpandedCards((prev) => ({
          ...prev,
          [plan.course_plan_id]: false,
        }));
      }
    };

    // UI Change 1: filter level2 by selected subject name
    const getFilteredLevel2 = (level2Array) => {
      if (!selectedSubjectSupersetName || !Array.isArray(level2Array)) return level2Array || [];
      return level2Array.filter(
        l2 => l2.name.toLowerCase() === selectedSubjectSupersetName.toLowerCase()
      );
    };

    return (
      <div
        key={plan.course_plan_id}
        className="course-plan-card"
        style={{
          border: "1px solid var(--DppCardBorder)",
          borderRadius: "8px",
          marginBottom: "16px",
          backgroundColor: isExpanded ? "var(--DppCardBackground)" : "var(--DppCardBackgroundCollapsed)",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.08)",
          opacity: isEnabled ? 1 : 0.7,
        }}
      >
        {/* Card Header */}
        <div
          onClick={handleHeaderClick}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            padding: "16px 20px",
            backgroundColor: isExpanded ? "var(--DppCardHeaderExpanded)" : "transparent",
            borderBottom: isExpanded ? "1px solid var(--DppCardHeaderBorder)" : "none",
            borderRadius: isExpanded ? "8px 8px 0 0" : "8px",
            cursor: isExpanded && isEnabled ? "pointer" : "default",
          }}
        >
          {/* Left: Plan Name with Applied Checkmark and Copy Icon */}
          <div style={{ display: "flex", alignItems: "flex-start", gap: "8px", minWidth: "200px" }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <h3
                  style={{
                    margin: 0,
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#6A6A6A",
                  }}
                >
                  {plan.plan_name}
                </h3>
                {cardData.isApplied && (
                  <IoCheckmarkCircle
                    style={{
                      color: "var(--DppCheckmarkColor)",
                      fontSize: "18px",
                      marginLeft: "2px",
                    }}
                  />
                )}
              </div>
              <p
                style={{
                  margin: "2px 0 0 0",
                  fontSize: "12px",
                  color: "#6A6A6A",
                }}
              >
                {plan.description}
              </p>
            </div>

            {/* Copy Icon */}
            {isExpanded && isEnabled && otherPlans.length > 0 && (
              <div
                className="copy-icon-container"
                style={{
                  position: "relative",
                  marginTop: "2px",
                }}
                ref={activeCopyDropdown === plan.course_plan_id ? copyDropdownRef : null}
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveCopyDropdown(
                      activeCopyDropdown === plan.course_plan_id ? null : plan.course_plan_id
                    );
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  title="Copy from another plan"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    style={{ color: "var(--DppLabelText)" }}
                  >
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                </button>

                {activeCopyDropdown === plan.course_plan_id && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      marginTop: "4px",
                      backgroundColor: "var(--DppDropdownBackground)",
                      border: "1px solid var(--DppDropdownBorder)",
                      borderRadius: "4px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      zIndex: 1000,
                      minWidth: "200px",
                    }}
                  >
                    <div style={{ padding: "8px 12px", borderBottom: "1px solid var(--DppDropdownItemBorder)", fontSize: "12px", color: "var(--DppDropdownSubText)", fontWeight: "500" }}>
                      Copy from...
                    </div>
                    {otherPlans.map((p) => (
                      <div
                        key={p.course_plan_id}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCopyFromPlan(plan.course_plan_id, p.course_plan_id);
                        }}
                        style={{
                          padding: "10px 12px",
                          cursor: "pointer",
                          fontSize: "13px",
                          borderBottom: "1px solid var(--DppDropdownSearchBorder)",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground)"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownBackground)"}
                      >
                        {p.plan_name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Middle and Right: DPP Name and Folder - Only when NOT expanded */}
          {!isExpanded && (
            <>
              <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
                <span style={{ color: "#6A6A6A", fontSize: "14px" }}>DPP Name</span>
                <span style={{ color: "#6A6A6A", fontSize: "14px" }}>▾</span>
                <span style={{ color: "#6A6A6A", fontSize: "14px", marginLeft: "4px" }}>
                  {cardData.dppName || "NA"}
                </span>
              </div>

              <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                <span style={{ color: "#6A6A6A", fontSize: "14px" }}>Folder</span>
                <span style={{ color: "#6A6A6A", fontSize: "14px" }}>▾</span>
                <span style={{ color: "#6A6A6A", fontSize: "14px", marginLeft: "4px" }}>
                  {cardData.folderName || "NA"}
                </span>
              </div>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleCardExpanded(plan.course_plan_id);
                }}
                disabled={!isEnabled}
                style={{
                  background: "none",
                  border: "none",
                  cursor: isEnabled ? "pointer" : "not-allowed",
                  padding: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                title={isEnabled ? "Expand" : "Select a question paper to enable"}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={isEnabled ? "#333" : "#999"}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
            </>
          )}

          {isExpanded && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleCardExpanded(plan.course_plan_id);
              }}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              title="Collapse"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#333"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="18 15 12 9 6 15"></polyline>
              </svg>
            </button>
          )}
        </div>

        {/* Expanded View */}
        {isExpanded && isEnabled && (
          <div style={{ padding: "20px", backgroundColor: "var(--DppDropdownBackground)" }}>
            {/* Row 1: DPP Name, Description, Start Date */}
            <div style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "20px",
            }}>
              <div>
                <label style={{ color: "GrayText", fontSize: "14px", display: "block", marginBottom: "6px" }}>
                  DPP Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  value={cardData.dppName}
                  onChange={(e) =>
                    updateCardData(plan.course_plan_id, "dppName", e.target.value)
                  }
                  placeholder="Enter DPP name"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: "1px solid var(--DppInputBorder)",
                    borderRadius: "4px",
                    fontSize: "14px",
                    boxSizing: "border-box",
                    color: "#6A6A6A",
                  }}
                />
              </div>
              <div>
                <label style={{ color: "GrayText", fontSize: "14px", display: "block", marginBottom: "6px" }}>
                  Description <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  value={cardData.description}
                  onChange={(e) =>
                    updateCardData(plan.course_plan_id, "description", e.target.value)
                  }
                  placeholder="Enter Description"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: "1px solid var(--DppInputBorder)",
                    borderRadius: "4px",
                    fontSize: "14px",
                    boxSizing: "border-box",
                    color: "#6A6A6A",
                  }}
                />
              </div>
              <div>
                <label style={{ color: "GrayText", fontSize: "14px", display: "block", marginBottom: "6px" }}>
                  Start Date <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="datetime-local"
                  min={getCurrentDateTime()}
                  value={cardData.startDate || ""}
                  onChange={(e) =>
                    updateCardData(plan.course_plan_id, "startDate", e.target.value)
                  }
                  // readOnly={cardData.startDate && new Date(cardData.startDate) < new Date()}
                  // disabled={cardData.startDate && new Date(cardData.startDate) < new Date()}
                  
                  // AFTER — locks only if the DB-loaded original start date is in the past
                  readOnly={!!(cardData.originalData?.dpp_window_start && new Date(cardData.originalData.dpp_window_start) < new Date())}
                  disabled={!!(cardData.originalData?.dpp_window_start && new Date(cardData.originalData.dpp_window_start) < new Date())}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: "1px solid var(--DppInputBorder)",
                    borderRadius: "4px",
                    fontSize: "14px",
                    color: "#6A6A6A",
                    boxSizing: "border-box",
                    cursor: cardData.startDate && new Date(cardData.startDate) < new Date() ? "not-allowed" : "pointer",
                    opacity: cardData.startDate && new Date(cardData.startDate) < new Date() ? 0.6 : 1,
                  }}
                />
              </div>
            </div>

            {/* Row 2: Term Date, Folder Name */}
            <div style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "20px",
              marginTop: "16px",
            }}>
              <div style={{ gridColumn: "1 / 2" }}>
                <label style={{ color: "GrayText", fontSize: "14px", display: "block", marginBottom: "6px" }}>
                  Term Date (Optional)
                </label>
                <input
                  type="datetime-local"
                  min={cardData.startDate || getCurrentDateTime()}
                  value={cardData.termDate || ""}
                  onChange={(e) =>
                    updateCardData(plan.course_plan_id, "termDate", e.target.value)
                  }
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: "1px solid var(--DppInputBorder)",
                    borderRadius: "4px",
                    fontSize: "14px",
                    color: "#6A6A6A",
                    boxSizing: "border-box",
                  }}
                />
              </div>

              <div style={{ gridColumn: "2 / 4" }}>
                <label style={{ color: "GrayText", fontSize: "14px", display: "block", marginBottom: "6px" }}>
                  Folder Name <span style={{ color: "red" }}>*</span>
                </label>
                <div
                  ref={activeFolderPicker === plan.course_plan_id ? folderPickerRef : null}
                  style={{ position: "relative" }}
                >
                  <input
                    type="text"
                    value={
                      folderSearchText[plan.course_plan_id] !== undefined
                        ? folderSearchText[plan.course_plan_id]
                        : (coursePlanCardData[plan.course_plan_id]?.folderName || "")
                    }
                    onChange={(e) => {
                      const searchVal = e.target.value;
                      setFolderSearchText(prev => ({ ...prev, [plan.course_plan_id]: searchVal }));
                      if (searchVal.trim()) {
                        setExpandedLevel1(null);
                        setExpandedLevel2(null);
                      }
                      if (!activeFolderPicker) {
                        setActiveFolderPicker(plan.course_plan_id);
                      }
                    }}
                    onFocus={() => {
                      if (activeFolderPicker !== plan.course_plan_id) {
                        setActiveFolderPicker(plan.course_plan_id);
                        setFolderSearchText(prev => ({ ...prev, [plan.course_plan_id]: "" }));
                      }
                    }}
                    placeholder="Select or search folder..."
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      paddingRight: "35px",
                      border: "1px solid var(--DppInputBorder)",
                      borderRadius: "4px",
                      fontSize: "14px",
                      boxSizing: "border-box",
                      backgroundColor: "var(--DppDropdownBackground)",
                      color: "#6A6A6A",
                    }}
                  />
                  <span
                    onClick={() => {
                      if (activeFolderPicker === plan.course_plan_id) {
                        setActiveFolderPicker(null);
                        setFolderSearchText(prev => {
                          const newState = { ...prev };
                          delete newState[plan.course_plan_id];
                          return newState;
                        });
                        setExpandedLevel1(null);
                        setExpandedLevel2(null);
                      } else {
                        setActiveFolderPicker(plan.course_plan_id);
                        setFolderSearchText(prev => ({ ...prev, [plan.course_plan_id]: "" }));
                      }
                    }}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#6A6A6A",
                      cursor: "pointer",
                    }}
                  >
                    ▼
                  </span>
                </div>
              </div>
            </div>

            {/* Folder Picker Dropdowns */}
            {activeFolderPicker === plan.course_plan_id && folderLevelData[plan.course_plan_id] && (
              <div ref={dropdownRef} style={{ position: "relative", zIndex: 99999, marginTop: "4px" }}>

                {/* Search Results */}
                {folderSearchText[plan.course_plan_id]?.trim() ? (
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "calc(33.33% + 10px)",
                      width: "calc(66.66% - 20px)",
                      backgroundColor: "var(--DppDropdownBackground)",
                      border: "1px solid var(--DppInputBorder)",
                      borderRadius: "4px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      zIndex: 99999,
                      maxHeight: "250px",
                      overflowY: "auto",
                    }}
                  >
                    {(() => {
                      const searchTerm = folderSearchText[plan.course_plan_id].toLowerCase();
                      const results = [];

                      // UI Change 1 (search): only search within the selected subject's level3 entries
                      folderLevelData[plan.course_plan_id].forEach((level1) => {
                        const filteredLevel2 = getFilteredLevel2(level1.level2);
                        filteredLevel2.forEach((level2) => {
                          // UI Change 2: only show level3 (chapter) results, not level2 (subject)
                          if (level2.level3) {
                            level2.level3.forEach((level3) => {
                              if (level3.name.toLowerCase().includes(searchTerm)) {
                                results.push({
                                  level1,
                                  level2,
                                  level3,
                                  displayPath: `${level1.name} > ${level2.name} > ${level3.name}`,
                                });
                              }
                            });
                          }
                        });
                      });

                      if (results.length === 0) {
                        return (
                          <div style={{ padding: "12px", color: "var(--DppLabelText)", textAlign: "center" }}>
                            No results found
                          </div>
                        );
                      }

                      return results.map((result, idx) => (
                        <div
                          key={idx}
                          onClick={() => {
                            const folderPath = result.displayPath;
                            const planId = plan.course_plan_id;
                            setCoursePlanCardData(prev => {
                              const existingData = prev[planId] || {};
                              return {
                                ...prev,
                                [planId]: {
                                  ...existingData,
                                  folderName: folderPath,
                                  folderPath: folderPath,
                                  selectedLevel1Id: result.level1.dpp_level1_id,
                                  selectedLevel2Id: result.level2.dpp_level2_id,
                                  selectedLevel3Id: result.level3.dpp_level3_id,
                                  isApplied: false,
                                  hasChanges: true,
                                },
                              };
                            });
                            setActiveFolderPicker(null);
                            setFolderSearchText(prev => {
                              const newState = { ...prev };
                              delete newState[planId];
                              return newState;
                            });
                            setExpandedLevel1(null);
                            setExpandedLevel2(null);
                          }}
                          style={{
                            padding: "10px 12px",
                            cursor: "pointer",
                            borderBottom: "1px solid var(--DppDropdownItemBorder)",
                            color: "var(--DppValueText)",
                            backgroundColor: "var(--DppDropdownBackground)",
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgb(212, 237, 218)"}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
                        >
                          {result.displayPath}
                        </div>
                      ));
                    })()}
                  </div>
                ) : (
                  /* Level 1 Dropdown — unselectable */
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "calc(33.33% + 10px)",
                      width: "220px",
                      backgroundColor: "var(--DppDropdownBackground)",
                      border: "1px solid var(--DppInputBorder)",
                      borderRadius: "4px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      maxHeight: "200px",
                      overflowY: "auto",
                      zIndex: 99999,
                    }}
                  >
                    {folderLevelData[plan.course_plan_id].map((level1) => {
                      // UI Change 1: only show ▶ if the selected subject exists under this level1
                      const filteredLevel2 = getFilteredLevel2(level1.level2);
                      return (
                        <div
                          key={level1.dpp_level1_id}
                          onMouseEnter={() => {
                            setExpandedLevel1(level1.dpp_level1_id);
                            setExpandedLevel2(null);
                          }}
                          style={{
                            padding: "10px 12px",
                            backgroundColor: expandedLevel1 === level1.dpp_level1_id ? "rgb(212, 237, 218)" : "#fff",
                            color: "var(--DppValueText)",
                            cursor: "default",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontWeight: "500",
                            borderBottom: "1px solid var(--DppDropdownItemBorder)",
                          }}
                        >
                          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level1.name}</span>
                          {filteredLevel2.length > 0 && (
                            <span style={{ fontSize: "10px", marginLeft: "4px", color: "var(--DppLabelText)" }}>▶</span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Level 2 Dropdown (Subject) — unselectable, only shows filtered subject */}
                {!folderSearchText[plan.course_plan_id]?.trim() && expandedLevel1 && (() => {
                  const level1Data = folderLevelData[plan.course_plan_id].find(l => l.dpp_level1_id === expandedLevel1);
                  const filteredLevel2 = getFilteredLevel2(level1Data?.level2);
                  if (!filteredLevel2.length) return null;
                  return (
                    <div
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "calc(33.33% + 232px)",
                        width: "220px",
                        backgroundColor: "var(--DppDropdownBackground)",
                        border: "1px solid var(--DppInputBorder)",
                        borderRadius: "4px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 100000,
                      }}
                    >
                      {filteredLevel2.map((level2) => (
                        <div
                          key={level2.dpp_level2_id}
                          onMouseEnter={() => {
                            setExpandedLevel2(level2.dpp_level2_id);
                          }}
                          // UI Change 2: no onClick — subject level is NOT selectable
                          style={{
                            padding: "10px 12px",
                            backgroundColor: expandedLevel2 === level2.dpp_level2_id ? "rgb(212, 237, 218)" : "#fff",
                            color: "var(--DppValueText)",
                            cursor: "default",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid var(--DppDropdownItemBorder)",
                          }}
                        >
                          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level2.name}</span>
                          {level2.level3 && level2.level3.length > 0 && (
                            <span style={{ fontSize: "10px", color: "var(--DppLabelText)", marginLeft: "4px" }}>▶</span>
                          )}
                        </div>
                      ))}
                    </div>
                  );
                })()}

                {/* Level 3 Dropdown (Chapter) — selectable */}
                {!folderSearchText[plan.course_plan_id]?.trim() && expandedLevel2 && (() => {
                  const level1Data = folderLevelData[plan.course_plan_id].find(l => l.dpp_level1_id === expandedLevel1);
                  const filteredLevel2 = getFilteredLevel2(level1Data?.level2);
                  const level2Data = filteredLevel2.find(l => l.dpp_level2_id === expandedLevel2);
                  if (!level2Data?.level3?.length) return null;
                  return (
                    <div
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "calc(33.33% + 454px)",
                        width: "220px",
                        backgroundColor: "var(--DppDropdownBackground)",
                        border: "1px solid var(--DppInputBorder)",
                        borderRadius: "4px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 100001,
                      }}
                    >
                      {level2Data.level3.map((level3) => (
                        <div
                          key={level3.dpp_level3_id}
                          onClick={() => {
                            // UI Change 2: only level3 (chapter) is selectable
                            const level1 = folderLevelData[plan.course_plan_id].find(l => l.dpp_level1_id === expandedLevel1);
                            const level2 = getFilteredLevel2(level1?.level2).find(l => l.dpp_level2_id === expandedLevel2);
                            const folderPath = `${level1.name} > ${level2.name} > ${level3.name}`;
                            const planId = plan.course_plan_id;
                            setCoursePlanCardData(prev => {
                              const existingData = prev[planId] || {};
                              return {
                                ...prev,
                                [planId]: {
                                  ...existingData,
                                  folderName: folderPath,
                                  folderPath: folderPath,
                                  selectedLevel1Id: level1.dpp_level1_id,
                                  selectedLevel2Id: level2.dpp_level2_id,
                                  selectedLevel3Id: level3.dpp_level3_id,
                                  isApplied: false,
                                  hasChanges: true,
                                },
                              };
                            });
                            setActiveFolderPicker(null);
                            setFolderSearchText(prev => {
                              const newState = { ...prev };
                              delete newState[planId];
                              return newState;
                            });
                            setExpandedLevel1(null);
                            setExpandedLevel2(null);
                          }}
                          style={{
                            padding: "10px 12px",
                            backgroundColor: "#fff",
                            color: "var(--DppValueText)",
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid var(--DppDropdownItemBorder)",
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgb(212, 237, 218)"}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
                        >
                          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level3.name}</span>
                        </div>
                      ))}
                    </div>
                  );
                })()}
              </div>
            )}

            {/* Card Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                marginTop: "20px",
                paddingTop: "16px",
                borderTop: "1px solid var(--DppSectionBorder)",
              }}
            >
              <button
                onClick={() => handleResetCard(plan.course_plan_id)}
                style={{
                  backgroundColor: "var(--DppButtonResetBackground)",
                  color: "var(--DppButtonResetText)",
                  border: "1px solid var(--DppButtonResetBorder)",
                  borderRadius: "4px",
                  padding: "10px 32px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                RESET
              </button>
              <button
                onClick={onApplyClick}
                disabled={!canApply}
                style={{
                  backgroundColor: canApply ? "var(--DppButtonApplyBackground)" : "var(--DppButtonApplyBackgroundDisabled)",
                  color: "var(--DppButtonApplyText)",
                  border: "none",
                  borderRadius: "4px",
                  padding: "10px 32px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: canApply ? "pointer" : "not-allowed",
                }}
              >
                APPLY
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="Leftmargin-Main-DIV">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
            width: "98%",
          }}
        >
          <div
            style={{
              fontSize: "30px",
              color: `${Colors.color1}`,
              fontWeight: "400",
            }}
          >
            DPP Scheduling
          </div>
          <div>
            <div className="row-cs-uni">
              <button
                className="create-test-section-btn"
                style={{
                  marginRight: "18px",
                  boxShadow: "0px 4px 4px 0px #00000040",
                }}
                onClick={() => navigate(-1)}
              >
                CANCEL
              </button>
              <button
                className="create-test-section-btn"
                style={{
                  marginRight: "0px",
                  boxShadow: "0px 4px 4px 0px #00000040",
                }}
                onClick={handleSave}
              >
                SAVE
              </button>
            </div>
          </div>
        </div>

        {/* QUESTION PAPER DETAIL Section */}
        <div className="Header-1-C424342">QUESTION PAPER DETAIL</div>
        <div className="Body-1-C424342">
          {/* Row 1: Course, Subject, Chapter */}
          <div className="row-cs">
            <div className="col-cs">
              <DropDown
                label="Select Course"
                style={{ width: "97%" }}
                setSelected={handleCourseChange}
                options={courses.map((course) => ({
                  label: course.course_name,
                  id: course.course_id,
                }))}
              />
            </div>
            <div className="col-cs">
              <DropDown
                key={`subject-${selectedCourseId}`}
                label="Select Subject"
                style={{ width: "97%" }}
                value={selectedSubjectSupersetId}
                setSelected={(selectedSupersetId) => {
                  const hasApplied = selectedQuestionPaperId && Object.values(coursePlanCardData).some(card => card.isApplied);

                  if (hasApplied && selectedSubjectSupersetId !== selectedSupersetId) {
                    setIsMessageBoxVisible(true);
                    setMessageBox(
                      <div className="Container-messageBOX">
                        <div className="messagebox-insider1">
                          <span>Changing the subject will reset the question paper selection and all applied course plan cards. Do you want to continue?</span>
                        </div>
                        <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                          <button
                            className="messagebox-cancel-btn-ok"
                            onClick={() => {
                              setIsMessageBoxVisible(false);
                              proceedWithSubjectChange(selectedSupersetId);
                            }}
                          >
                            YES
                          </button>
                          <button
                            className="messagebox-cancel-btn-ok"
                            onClick={() => {
                              setIsMessageBoxVisible(false);
                            }}
                          >
                            NO
                          </button>
                        </div>
                      </div>
                    );
                    setActiveImg(WarnningIcon);
                    return;
                  }

                  proceedWithSubjectChange(selectedSupersetId);
                }}
                options={(() => {
                  const supersetMap = new Map();
                  if (Array.isArray(subjects)) {
                    subjects.forEach((subject) => {
                      if (!supersetMap.has(subject.subject_superset_id)) {
                        supersetMap.set(subject.subject_superset_id, {
                          label: subject.subject_superset_name,
                          id: subject.subject_superset_id,
                        });
                      }
                    });
                  }
                  return Array.from(supersetMap.values());
                })()}
              />
            </div>
            <div className="col-cs">
              <MultiSelectSearchDropdown
                label="Select Chapter (Optional)"
                width="97%"
                selected={selectedChapterId}
                setSelected={(selectedIds) => {
                  setSelectedChapterId(selectedIds);
                  if (Array.isArray(selectedIds) && selectedIds.length > 0) {
                    const selectedChapters = chapters.filter((chapter) =>
                      selectedIds.includes(chapter.chapter_id)
                    );
                    const names = selectedChapters
                      .map((chapter) => chapter.chapter_name)
                      .join(", ");
                    setSelectedChapterName(names);
                  } else {
                    setSelectedChapterName("");
                  }
                }}
                options={chapters.map((chapter) => ({
                  label: chapter.chapter_name,
                  id: chapter.chapter_id,
                }))}
              />
            </div>
          </div>

          {/* Row 2: Topic, Question Paper Name, Question Paper Description */}
          <div className="row-cs">
            <div className="col-cs">
              <MultiSelectSearchDropdown
                label="Select Topic (Optional)"
                width="97%"
                selected={selectedTopicId}
                setSelected={(selectedIds) => {
                  setSelectedTopicId(selectedIds);
                  if (Array.isArray(selectedIds) && selectedIds.length > 0) {
                    const selectedTopics = Array.isArray(topics)
                      ? topics.filter((topic) =>
                          selectedIds.includes(topic.topic_id)
                        )
                      : [];
                    const names = selectedTopics
                      .map((topic) => topic.topic_name)
                      .join(", ");
                    setSelectedTopicName(names);
                  } else {
                    setSelectedTopicName("");
                  }
                }}
                options={
                  Array.isArray(topics)
                    ? topics.map((topic) => ({
                        label: topic.topic_name,
                        id: topic.topic_id,
                      }))
                    : []
                }
                isRequired={false}
              />
            </div>
            <div className="col-cs">
              <DropDown
                key={`qp-${selectedSubjectIds.join('-')}-${selectedChapterId?.join("-")}-${selectedTopicId?.join("-")}`}
                label="Question Paper Name"
                style={{ width: "97%" }}
                setSelected={handleQuestionPaperChange}
                options={questionPapers.map((qp) => ({
                  label: qp.ques_paper_name,
                  id: qp.ques_paper_id,
                }))}
              />
            </div>
            <div className="col-cs">
              <InputComponent
                label="Question Paper Description"
                style={{ width: "97%" }}
                value={selectedQuestionPaperDescription}
                isRequired={false}
                disable={true}
              />
            </div>
          </div>

          {/* Row 3: Question Paper Created By, Question Paper Subjects */}
          <div className="row-cs">
            <div className="col-cs">
              <InputComponent
                label="Question Paper Created By"
                style={{ width: "97%" }}
                value={selectedQuestionPaperCreatedBy}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">
              <InputComponent
                label="Question Paper Subjects"
                style={{ width: "97%" }}
                value={selectedQuestionPaperSubjects}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">
              {/* Empty placeholder for alignment */}
            </div>
          </div>

          {/* Instructions Editor */}
          <div style={{ marginRight: "15px", marginBottom: "20px" }}>
            <TextEditor
              templates={testTemplates}
              value={instructionsHtml}
              setValue={setInstructionsHtml}
            />
          </div>
        </div>

        {/* COURSE PLAN CARDS Section */}
        {selectedCourseId && coursePlans.length > 0 && (
          <div style={{ marginTop: "30px" }}>
            <div style={{
              fontSize: "15px",
              fontWeight: "600",
              marginBottom: "16px",
              color: "#6A6A6A",
              fontFamily: "'ABeeZee', sans-serif",
              lineHeight: "14px",
            }}>
              COURSE PLAN DETAILS
            </div>
            <div style={{ width: "98%" }}>
              {coursePlans.map((plan) => renderCoursePlanCard(plan))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DppScheduling;
